import { i as e, n as t, r as n, t as r } from "./RadioGroup-Dh3wrGNn.js";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
import * as s from "react";
import { Fragment as c, cloneElement as l, useEffect as u, useId as d, useLayoutEffect as f, useMemo as p, useRef as m, useState as h } from "react";
import * as g from "react-dom";
// \0rolldown/runtime.js
var _ = Object.create, v = Object.defineProperty, y = Object.getOwnPropertyDescriptor, b = Object.getOwnPropertyNames, x = Object.getPrototypeOf, S = Object.prototype.hasOwnProperty, C = (e, t) => () => (t || (e((t = { exports: {} }).exports, t, t.exports), e = null), t.exports), w = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = b(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !S.call(e, s) && s !== n && v(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = y(t, s)) || r.enumerable
	});
	return e;
}, T = (e, t, n) => (n = e == null ? {} : _(x(e)), w(t || !e || !e.__esModule || !S.call(e, "default") ? v(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), E = {
	"arrows.arrow-left": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M17 11H9.41l3.3-3.29a1.004 1.004 0 0 0-1.42-1.42l-5 5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l5 5a1.002 1.002 0 0 0 1.639-.325 1 1 0 0 0-.219-1.095L9.41 13H17a1 1 0 0 0 0-2"
		})
	}),
	"arrows.arrow-right": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M17.92 11.62a1 1 0 0 0-.21-.33l-5-5a1.003 1.003 0 1 0-1.42 1.42l3.3 3.29H7a1 1 0 0 0 0 2h7.59l-3.3 3.29a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l5-5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76"
		})
	}),
	"arrows.chevron-down": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42"
		})
	}),
	"arrows.chevron-left": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m8.46 11.29 5.66-5.65a1 1 0 1 1 1.42 1.41l-4.95 5L15.54 17a1 1 0 0 1 0 1.41 1 1 0 0 1-.71.3 1 1 0 0 1-.71-.3l-5.66-5.65a1 1 0 0 1 0-1.47"
		})
	}),
	"arrows.chevron-right": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M15.54 11.29 9.88 5.64a1 1 0 1 0-1.42 1.41l4.95 5L8.46 17a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l5.66-5.65a1 1 0 0 0 0-1.47"
		})
	}),
	"arrows.trending-up": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21.92 6.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 6h-5a1 1 0 0 0 0 2h2.59L13 13.59l-3.29-3.3a1 1 0 0 0-1.42 0l-6 6a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219L9 12.41l3.29 3.3a1 1 0 0 0 1.42 0L20 9.41V12a1 1 0 0 0 2 0V7a1 1 0 0 0-.08-.38"
		})
	}),
	"business.calendar": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-12h-1V2a1 1 0 0 0-2 0v1H8V2a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16zm0-11H4V6a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V5h8v1a1 1 0 0 0 2 0V5h1a1 1 0 0 1 1 1zM7 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
		})
	}),
	"cloud-and-web.two-columns": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M11 20H4V4h7zm9 0h-7V4h7z"
		})
	}),
	"content.short-text": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M13 13.5H3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m8-5H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2"
		})
	}),
	"file-and-folder.add-document": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M20 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3zm-4-5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 0 0 0-2"
		})
	}),
	"file-and-folder.add-file": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M20 18h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2m-7 2H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v3a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.1 0 1.1 1.1 0 0 0-.31-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L15.59 8H14a1 1 0 0 1-1-1zM8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5 8H8a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2m1-4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2"
		})
	}),
	"file-and-folder.add-folder": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M14 12.5h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 0 0 0-2m5-7h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a1 1 0 0 1 .584.187c.17.122.298.294.366.493l.54 1.64a1 1 0 0 0 .365.493A1 1 0 0 0 12 7.5h7a1 1 0 0 1 1 1z"
		})
	}),
	"file-and-folder.archive": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M10 13h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m9-10H5a3 3 0 0 0-1 5.82V18a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.82A3 3 0 0 0 19 3m-1 15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h12zm1-11H5a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2"
		})
	}),
	"file-and-folder.document": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M9 10h1a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zm11-3.06a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94m-6-3.53L16.59 8H15a1 1 0 0 1-1-1zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3zm-3-3H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2"
		})
	}),
	"file-and-folder.restore": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M11.44 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 1 1 11.44 20a1 1 0 1 0 0 2 10 10 0 0 0 0-20m0 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-1V9a1 1 0 0 0-1-1"
		})
	}),
	"medical.add-book": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M13 9h-2V7a1 1 0 0 0-2 0v2H7a1 1 0 0 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 0 0 0-2m5 6V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3M4 15V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m17-9a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1 1 0 0 0 0 2h10a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1"
		})
	}),
	"medical.ambulance": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M10.5 9.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 0 0 0-2m12.43 2.15-.06-.11a.6.6 0 0 0-.07-.14l-2.4-3.2A3 3 0 0 0 18 7h-2V6a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v11a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-.07-.35M6 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2m8-3H8.22a3 3 0 0 0-4.44 0H3V6a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1zm2-7h2a1 1 0 0 1 .8.4L20 11h-4zm2 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3-3h-.78a3 3 0 0 0-4.22-.22V13h5z"
		})
	}),
	"medical.medicine": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M19.5 4.5a5.12 5.12 0 0 0-7.24 0L4.5 12.26a5.12 5.12 0 1 0 7.24 7.24l7.76-7.76a5.12 5.12 0 0 0 0-7.24m-9.18 13.59a3.21 3.21 0 0 1-4.41 0 3.13 3.13 0 0 1 0-4.41l3.18-3.18 4.41 4.41zm7.77-7.77-3.18 3.18-4.41-4.41 3.18-3.18a3.12 3.12 0 0 1 4.41 4.41"
		})
	}),
	"medical.pulse": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21 11h-3.94a.8.8 0 0 0-.21 0h-.17q-.078.045-.15.1-.085.056-.16.12a1 1 0 0 0-.09.13 1.3 1.3 0 0 0-.12.2l-1.6 4.41-4.17-11.3a1 1 0 0 0-1.88 0L6.2 11H3a1 1 0 0 0 0 2h4.3a1 1 0 0 0 .16-.1 2 2 0 0 0 .16-.12l.09-.13q.072-.093.12-.2l1.62-4.53 4.16 11.42a1 1 0 0 0 1.88 0l2.3-6.34H21a1 1 0 0 0 0-2"
		})
	}),
	"medical.stethoscope": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21.8 10c-.4-1.2-1.6-2-2.8-2-1.7 0-3 1.3-3 3 0 1.3.8 2.4 2 2.8v1.7c0 2.5-2 4.5-4.5 4.5S9 18 9 15.5v-.6c2.9-.5 5-3 5-5.9V3c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1s.4 1 1 1h1v5c0 2.2-1.8 4-4 4s-4-1.8-4-4V4h1c.6 0 1-.4 1-1s-.4-1-1-1H3c-.6 0-1 .4-1 1v6c0 2.9 2.1 5.4 5 5.9v.6c0 3.6 2.9 6.5 6.5 6.5s6.5-2.9 6.5-6.5v-1.7c1.6-.5 2.4-2.2 1.8-3.8"
		})
	}),
	"photography-tools.eye": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8M12 18c-3.17 0-6.17-2.29-7.9-6C5.83 8.29 8.83 6 12 6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6m0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
		})
	}),
	"photography-tools.focus": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M8 20H5a1 1 0 0 1-1-1v-3a1 1 0 1 0-2 0v3a3 3 0 0 0 3 3h3a1 1 0 0 0 0-2M3 9a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1m16-7h-3a1 1 0 1 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3m-3 10a1 1 0 0 0-1-1h-2V9a1 1 0 0 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 1-1m5 3a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1"
		})
	}),
	"security.lock": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 13a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m5-4V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3M9 7a3 3 0 1 1 6 0v2H9zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z"
		})
	}),
	"security.shield": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M19.63 3.65a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27A1 1 0 0 0 4 4.43v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78M18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39zm-4.46-2.29-2.69 2.7-.89-.9a1.004 1.004 0 0 0-1.42 1.42l1.6 1.6a1 1 0 0 0 1.42 0L15 11a1.004 1.004 0 1 0-1.42-1.42z"
		})
	}),
	"sign-and-symbol.block": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 0 1-8-8 7.92 7.92 0 0 1 1.69-4.9L16.9 18.31A7.92 7.92 0 0 1 12 20m6.31-3.1L7.1 5.69A7.92 7.92 0 0 1 12 4a8 8 0 0 1 8 8 7.92 7.92 0 0 1-1.69 4.9"
		})
	}),
	"user-interface.checkmark-circle": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m14.72 8.79-4.29 4.3-1.65-1.65a1 1 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 1.41 0l5-5a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20"
		})
	}),
	"user-interface.checkmark": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 10 7",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M9.155.197a.667.667 0 0 0-.947 0L3.241 5.171 1.155 3.077a.681.681 0 1 0-.947.98l2.56 2.56a.667.667 0 0 0 .947 0l5.44-5.44a.667.667 0 0 0 0-.98"
		})
	}),
	"user-interface.close-bold": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 8 8",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m4.944 4.003 2.867-2.86a.67.67 0 0 0-.947-.947l-2.86 2.867L1.144.196a.67.67 0 0 0-.947.947l2.867 2.86-2.867 2.86a.667.667 0 0 0 .217 1.092.67.67 0 0 0 .73-.146l2.86-2.866 2.86 2.866a.666.666 0 0 0 1.092-.217.67.67 0 0 0-.145-.73z"
		})
	}),
	"user-interface.close-circle": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M15.71 8.29a1 1 0 0 0-1.42 0L12 10.59l-2.29-2.3a1.004 1.004 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3 2.29 2.3a1 1 0 0 0 1.095.219 1 1 0 0 0 .325-.22 1 1 0 0 0 0-1.42L13.41 12l2.3-2.29a1 1 0 0 0 0-1.42m3.36-3.36A10 10 0 1 0 4.93 19.07 10 10 0 1 0 19.07 4.93m-1.41 12.73A8 8 0 1 1 20 12a7.95 7.95 0 0 1-2.34 5.66"
		})
	}),
	"user-interface.close": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m13.41 12 6.3-6.29a1.004 1.004 0 1 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 0 0-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1 1 0 0 0 1.42 0 1 1 0 0 0 .219-1.095 1 1 0 0 0-.22-.325z"
		})
	}),
	"user-interface.copy": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21 8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H10a3 3 0 0 0-3 3v1H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3V8.94m-6-3.53L17.59 8H16a1 1 0 0 1-1-1ZM15 19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1v7a3 3 0 0 0 3 3h5Zm4-4a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3Z"
		})
	}),
	"user-interface.dislike": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M19 2H6.27a3 3 0 0 0-2.95 2.46l-1.27 7A3 3 0 0 0 5 15h4.56L9 16.43A4.13 4.13 0 0 0 12.89 22a1 1 0 0 0 .91-.59L16.65 15H19a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-4 11.79-2.72 6.12a2.13 2.13 0 0 1-1.38-2.78l.53-1.43A2 2 0 0 0 9.56 13H5a1 1 0 0 1-.77-.36 1 1 0 0 1-.23-.82l1.27-7a1 1 0 0 1 1-.82H15zM20 12a1 1 0 0 1-1 1h-2V4h2a1 1 0 0 1 1 1z"
		})
	}),
	"user-interface.ellipsis-horizontal": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m14 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
		})
	}),
	"user-interface.exclamation-mark-circle": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 11a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m.38-3.92a1 1 0 0 0-.76 0 1 1 0 0 0-.33.21 1.2 1.2 0 0 0-.21.33 1 1 0 0 0 .21 1.09q.147.133.33.21A1 1 0 0 0 13 8a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-.33-.21M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20"
		})
	}),
	"user-interface.exclamation-mark-triangle": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10.67 1.47-8.05-14a3 3 0 0 0-5.24 0l-8 14A3 3 0 0 0 3.94 22h16.12a3 3 0 0 0 2.61-4.53m-1.73 2a1 1 0 0 1-.88.51H3.94a1 1 0 0 1-.88-.51 1 1 0 0 1 0-1l8-14a1 1 0 0 1 1.78 0l8.05 14a1 1 0 0 1 .05 1.02zM12 8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"
		})
	}),
	"user-interface.house": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m20 8-6-5.26a3 3 0 0 0-4 0L4 8a3 3 0 0 0-1 2.26V19a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8.75A3 3 0 0 0 20 8m-6 12h-4v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm5-1a1 1 0 0 1-1 1h-2v-5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1v-8.75a1 1 0 0 1 .34-.75l6-5.25a1 1 0 0 1 1.32 0l6 5.25a1 1 0 0 1 .34.75z"
		})
	}),
	"user-interface.like": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21.3 10.08A3 3 0 0 0 19 9h-4.56L15 7.57A4.13 4.13 0 0 0 11.11 2a1 1 0 0 0-.91.59L7.35 9H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12.73a3 3 0 0 0 2.95-2.46l1.27-7a3 3 0 0 0-.65-2.46M7 20H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2zm13-7.82-1.27 7a1 1 0 0 1-1 .82H9v-9.79l2.72-6.12a2.11 2.11 0 0 1 1.38 2.78l-.53 1.43a2 2 0 0 0 1.87 2.7H19a1 1 0 0 1 .77.36 1 1 0 0 1 .23.82"
		})
	}),
	"user-interface.magnifier": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m19.785 18.649-2.968-2.944a7.2 7.2 0 1 0-1.112 1.112l2.944 2.944a.8.8 0 0 0 1.136 0 .8.8 0 0 0 0-1.112m-8.568-1.832a5.6 5.6 0 1 1 0-11.2 5.6 5.6 0 0 1 0 11.2"
		})
	}),
	"user-interface.move": (e) => /* @__PURE__ */ o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: [
			/* @__PURE__ */ a("circle", {
				cx: 9,
				cy: 6,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 9,
				cy: 12,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 9,
				cy: 18,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 15,
				cy: 6,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 15,
				cy: 12,
				r: 2,
				fill: "currentColor"
			}),
			/* @__PURE__ */ a("circle", {
				cx: 15,
				cy: 18,
				r: 2,
				fill: "currentColor"
			})
		]
	}),
	"user-interface.paper-plane": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m20.34 9.32-14-7a3 3 0 0 0-4.08 3.9l2.4 5.37a1.06 1.06 0 0 1 0 .82l-2.4 5.37A3 3 0 0 0 5 22a3.14 3.14 0 0 0 1.35-.32l14-7a3 3 0 0 0 0-5.36zm-.89 3.57-14 7a1 1 0 0 1-1.35-1.3l2.39-5.37a2 2 0 0 0 .08-.22h6.89a1 1 0 0 0 0-2H6.57a2 2 0 0 0-.08-.22L4.1 5.41a1 1 0 0 1 1.35-1.3l14 7a1 1 0 0 1 0 1.78"
		})
	}),
	"user-interface.pen": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M21 12a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1m-15 .76V17a1 1 0 0 0 1 1h4.24a1 1 0 0 0 .71-.29l6.92-6.93L21.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71m10.76-8.35 2.83 2.83-1.42 1.42-2.83-2.83zM8 13.17l5.93-5.93 2.83 2.83L10.83 16H8z"
		})
	}),
	"user-interface.pencil": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M22 7.24a1 1 0 0 0-.29-.71l-4.24-4.24a1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29l-2.83 2.83L2.29 16.05a1 1 0 0 0-.29.71V21a1 1 0 0 0 1 1h4.24a1 1 0 0 0 .76-.29l10.87-10.93L21.71 8q.138-.146.22-.33.015-.12 0-.24a.7.7 0 0 0 0-.14zM6.83 20H4v-2.83l9.93-9.93 2.83 2.83zM18.17 8.66l-2.83-2.83 1.42-1.41 2.82 2.82z"
		})
	}),
	"user-interface.plus": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2"
		})
	}),
	"user-interface.setting": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "m21.32 9.55-1.89-.63.89-1.78A1 1 0 0 0 20.13 6L18 3.87a1 1 0 0 0-1.15-.19l-1.78.89-.63-1.89A1 1 0 0 0 13.5 2h-3a1 1 0 0 0-.95.68l-.63 1.89-1.78-.89A1 1 0 0 0 6 3.87L3.87 6a1 1 0 0 0-.19 1.15l.89 1.78-1.89.63a1 1 0 0 0-.68.94v3a1 1 0 0 0 .68.95l1.89.63-.89 1.78A1 1 0 0 0 3.87 18L6 20.13a1 1 0 0 0 1.15.19l1.78-.89.63 1.89a1 1 0 0 0 .95.68h3a1 1 0 0 0 .95-.68l.63-1.89 1.78.89a1 1 0 0 0 1.13-.19L20.13 18a1 1 0 0 0 .19-1.15l-.89-1.78 1.89-.63a1 1 0 0 0 .68-.94v-3a1 1 0 0 0-.68-.95M20 12.78l-1.2.4A2 2 0 0 0 17.64 16l.57 1.14-1.1 1.1-1.11-.6a2 2 0 0 0-2.79 1.16l-.4 1.2h-1.59l-.4-1.2A2 2 0 0 0 8 17.64l-1.14.57-1.1-1.1.6-1.11a2 2 0 0 0-1.16-2.82l-1.2-.4v-1.56l1.2-.4A2 2 0 0 0 6.36 8l-.57-1.11 1.1-1.1L8 6.36a2 2 0 0 0 2.82-1.16l.4-1.2h1.56l.4 1.2A2 2 0 0 0 16 6.36l1.14-.57 1.1 1.1-.6 1.11a2 2 0 0 0 1.16 2.79l1.2.4zM12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
		})
	}),
	"user-interface.trash": (e) => /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "1em",
		height: "1em",
		fill: "none",
		viewBox: "0 0 24 24",
		...e,
		children: /* @__PURE__ */ a("path", {
			fill: "currentColor",
			d: "M10 18a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1M20 6h-4V5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H4a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8h1a1 1 0 1 0 0-2M10 5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4zm7 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8h10zm-3-1a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1"
		})
	})
}, D = {
	violet: "violet",
	blue: "blue",
	green: "green",
	lilac: "lilac",
	yellow: "yellow",
	grey: "grey",
	red: "red",
	white: "white",
	inherit: "inherit"
}, O = (e) => e === D.inherit ? "currentColor" : e === D.white ? "var(--color-white)" : `var(--color-${e}-500)`, k = ({ name: e, size: t = 24, color: n = D.violet, ariaLabel: r }) => {
	let i = E[e], o = O(n);
	return /* @__PURE__ */ a(i, {
		"aria-hidden": !r || void 0,
		"aria-label": r,
		color: o,
		height: t,
		role: r ? "img" : void 0,
		width: t
	});
}, A = [
	"primary",
	"accent",
	"link",
	"danger",
	"neutral"
], j = [
	"solid",
	"outline",
	"ghost"
], M = [
	"xs",
	"s",
	"m",
	"l"
], N = {
	leading: "leading",
	trailing: "trailing"
}, P = ({ children: e, icon: t, iconColor: n, iconPosition: r, iconSize: i = 16, "aria-label": s, intent: c = "primary", variant: l = "solid", size: u = "l", type: d, ...f }) => {
	let p = !(typeof e == "string" && e.trim().length > 0), m = [
		"button",
		`intent-${c}`,
		`variant-${l}`,
		`size-${u}`,
		...p ? ["icon-only"] : []
	].join(" "), h = t ? /* @__PURE__ */ a(k, {
		ariaLabel: p ? s : void 0,
		color: n,
		name: t,
		size: i
	}) : null;
	return /* @__PURE__ */ o("button", {
		"aria-label": s,
		className: m,
		type: d ?? "button",
		...f,
		children: [
			p || r === N.leading ? h : null,
			e,
			!p && r === N.trailing ? h : null
		]
	});
}, F = {
	default: "default",
	warning: "warning"
}, I = {
	small: "small",
	medium: "medium",
	large: "large"
}, ee = {
	lilac: "lilac",
	blue: "blue",
	yellow: "yellow",
	violet: "violet",
	red: "red",
	green: "green",
	grey: "grey",
	gradient: "gradient"
}, te = 16, ne = (e) => {
	let { children: t, size: n = I.medium, className: r, type: i = F.default, color: s = ee.lilac, icon: c, ...l } = e, u = i === F.warning, d = c !== void 0 && n !== I.small ? c : void 0, f = (u ? [
		"badge",
		"badge-type-warning",
		`badge-size-${n}`,
		r
	] : [
		"badge",
		"badge-type-default",
		`badge-color-${s}`,
		`badge-size-${n}`,
		r
	]).filter(Boolean).join(" ");
	return /* @__PURE__ */ o("span", {
		className: f,
		...l,
		children: [d == null ? null : /* @__PURE__ */ a("span", {
			className: "badge-icon-slot",
			children: /* @__PURE__ */ a(k, {
				color: D.inherit,
				name: d,
				size: te
			})
		}), /* @__PURE__ */ a("span", {
			className: "badge-text",
			children: t
		})]
	});
}, re = {
	large: "large",
	medium: "medium",
	micro: "micro"
}, ie = {
	violet: "violet",
	blue: "blue",
	green: "green",
	lilac: "lilac",
	yellow: "yellow",
	grey: "grey"
}, ae = {
	filled: "filled",
	outlined: "outlined"
}, oe = {
	idle: "idle",
	active: "active",
	disabled: "disabled"
}, se = 18, ce = 10, le = (e) => {
	let { children: t, frontIcon: n, variant: r = ae.outlined, size: i = re.large, color: s = ie.violet, state: c = oe.idle, removable: l = !1, onRemove: u, className: d, ...f } = e, p = c === oe.disabled, m = [
		"chip",
		`chip-variant-${r}`,
		`chip-size-${i}`,
		`chip-color-${s}`,
		`chip-state-${c}`,
		d
	].filter(Boolean).join(" "), h = (e) => {
		e.stopPropagation(), !p && u && u();
	};
	return /* @__PURE__ */ o("span", {
		className: m,
		...f,
		children: [
			n == null ? null : /* @__PURE__ */ a("span", {
				className: "chip-icon-slot",
				children: /* @__PURE__ */ a(k, {
					name: n,
					size: se
				})
			}),
			/* @__PURE__ */ a("span", {
				className: "chip-text",
				children: t
			}),
			l && u ? /* @__PURE__ */ a("button", {
				type: "button",
				className: "chip-remove-button",
				onClick: h,
				disabled: p,
				"aria-label": "Remove",
				children: /* @__PURE__ */ a(k, {
					name: "user-interface.close",
					size: ce
				})
			}) : null
		]
	});
}, L = /* @__PURE__ */ T((/* @__PURE__ */ C(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})))(), 1), ue = {
	small: "small",
	medium: "medium"
}, de = {
	leading: "leading",
	trailing: "trailing"
}, fe = {
	small: 14,
	medium: 16
}, pe = (e, t) => {
	let n = e.iconPosition ?? de.leading, r = e.text === void 0, s = e.icon === void 0 ? null : /* @__PURE__ */ a(k, {
		name: e.icon,
		size: t
	});
	return /* @__PURE__ */ o(i, { children: [
		n === de.leading && s,
		!r && /* @__PURE__ */ a("span", {
			className: "tab-label",
			children: e.text
		}),
		n === de.trailing && s
	] });
}, me = (e) => {
	let { items: t, renderItem: n, size: r = ue.medium, "aria-label": i, className: o } = e, s = fe[r];
	return /* @__PURE__ */ a("nav", {
		"aria-label": i,
		className: (0, L.default)("tab-bar", `size-${r}`, o),
		children: t.map((e) => {
			let t = e.text === void 0, r = (0, L.default)("tab", { "icon-only": t }), i = pe(e, s), o = e.href ?? e.text;
			return e.disabled || e.href === void 0 ? /* @__PURE__ */ a("span", {
				"aria-disabled": "true",
				className: r,
				"data-disabled": "",
				"data-state": "inactive",
				children: i
			}, o) : n === void 0 ? /* @__PURE__ */ a("a", {
				"aria-current": e.active ? "page" : void 0,
				className: (0, L.default)(r, { "tab-active": e.active }),
				"data-state": e.active ? "active" : "inactive",
				href: e.href,
				children: i
			}, o) : /* @__PURE__ */ a(c, { children: n({
				className: r,
				activeClassName: "tab-active",
				content: i,
				item: e
			}) }, o);
		})
	});
}, he = (e, t, n) => {
	let r = t.indexOf(e);
	return r === -1 || t.length === 0 ? null : n === "Home" ? t[0] ?? null : n === "End" ? t[t.length - 1] ?? null : t[(r + (n === "ArrowRight" || n === "ArrowDown" ? 1 : -1) + t.length) % t.length] ?? null;
}, ge = (e) => {
	let { items: t, onValueChange: n, size: r = ue.medium, value: i, onKeyDown: o, className: s, ...c } = e, l = fe[r], u = p(() => t.map((e) => ({
		disabled: !!e.disabled,
		value: e.value
	})), [t]), d = u.find((e) => !e.disabled)?.value, [f, m] = h(() => u.find((e) => e.value === i && !e.disabled)?.value ?? d);
	return /* @__PURE__ */ a("div", {
		className: (0, L.default)("tab-bar", `size-${r}`, s),
		role: "group",
		onKeyDown: (e) => {
			if (o?.(e), e.defaultPrevented) return;
			let t = e.target;
			if (!(t instanceof HTMLButtonElement) || t.dataset.tabValue === void 0) return;
			let r = e.key === "ArrowLeft", i = e.key === "ArrowRight", a = e.key === "Home" || e.key === "End";
			if (e.key === "Enter" || e.key === " ") {
				let r = t.dataset.value;
				r !== void 0 && (e.preventDefault(), n(r));
				return;
			}
			if (!r && !i && !a) return;
			let s = he(t, Array.from(e.currentTarget.querySelectorAll("button[data-tab-value]:not(:disabled)")), e.key);
			s !== null && (e.preventDefault(), s.focus());
		},
		...c,
		children: t.map((e) => {
			let t = e.text === void 0, r = i === e.value, o = f === e.value;
			return /* @__PURE__ */ a("button", {
				"aria-label": e["aria-label"],
				"aria-pressed": r,
				className: (0, L.default)("tab", { "icon-only": t }),
				"data-disabled": e.disabled ? "" : void 0,
				"data-state": r ? "active" : "inactive",
				"data-value": e.value,
				"data-tab-value": e.value,
				disabled: e.disabled,
				tabIndex: o ? 0 : -1,
				type: "button",
				onClick: () => n(e.value),
				onFocus: () => m(e.value),
				children: pe(e, l)
			}, e.value);
		})
	});
}, _e = (e) => {
	if (e.nav) return /* @__PURE__ */ a(me, { ...e });
	let { nav: t, ...n } = e;
	return /* @__PURE__ */ a(ge, { ...n });
}, ve = (e) => e ? Array.from(e.querySelectorAll("[role=\"menuitem\"]")) : [], ye = (e) => `--menu-${e.replace(/[^a-zA-Z0-9]/g, "")}`, be = typeof CSS < "u" && typeof CSS.supports == "function" && CSS.supports("anchor-name: --menu"), xe = (e) => {
	let { trigger: t, label: n, triggerLabel: r, children: i, align: s = "start", triggerClassName: c } = e, [l, p] = h(!1), g = m(null), _ = m(null), v = d(), y = ye(d());
	return u(() => {
		let e = _.current;
		if (!e) return;
		let t = (e) => {
			p(e.newState === "open");
		};
		return e.addEventListener("toggle", t), () => {
			e.removeEventListener("toggle", t);
		};
	}, []), u(() => {
		if (!l) return;
		let e = ve(_.current), t = e.find((e) => e.getAttribute("aria-current") === "true") ?? e[0];
		t?.focus(), t?.scrollIntoView({ block: "nearest" });
	}, [l]), f(() => {
		if (!l || be) return;
		let e = _.current, t = g.current;
		if (!e || !t) return;
		let n = () => {
			let n = t.getBoundingClientRect();
			e.style.top = `${n.bottom + 6}px`, s === "end" ? e.style.left = `${n.right - e.offsetWidth}px` : e.style.left = `${n.left}px`;
		};
		return n(), window.addEventListener("scroll", n, !0), window.addEventListener("resize", n), () => {
			window.removeEventListener("scroll", n, !0), window.removeEventListener("resize", n);
		};
	}, [l, s]), /* @__PURE__ */ o("div", {
		className: "menu",
		children: [/* @__PURE__ */ a("button", {
			ref: g,
			type: "button",
			className: (0, L.default)("menu-trigger", c),
			style: { anchorName: y },
			"aria-label": r,
			"aria-haspopup": "menu",
			"aria-expanded": l,
			"aria-controls": v,
			popoverTarget: v,
			children: t(l)
		}), /* @__PURE__ */ a("div", {
			ref: _,
			id: v,
			popover: "auto",
			role: "menu",
			tabIndex: -1,
			"aria-label": n,
			className: (0, L.default)("menu-popup", `menu-popup--${s}`),
			style: { positionAnchor: y },
			onClick: () => _.current?.hidePopover(),
			onKeyDown: (e) => {
				let t = ve(_.current);
				if (t.length === 0) return;
				let n = t.indexOf(document.activeElement);
				e.key === "ArrowDown" ? (e.preventDefault(), t[n < 0 ? 0 : (n + 1) % t.length]?.focus()) : e.key === "ArrowUp" ? (e.preventDefault(), t[n < 0 ? t.length - 1 : (n - 1 + t.length) % t.length]?.focus()) : e.key === "Home" ? (e.preventDefault(), t[0]?.focus()) : e.key === "End" && (e.preventDefault(), t[t.length - 1]?.focus());
			},
			children: /* @__PURE__ */ a("div", {
				className: "menu-scroll",
				role: "none",
				children: i
			})
		})]
	});
}, R = {
	ARROWS_ARROW_LEFT: "arrows.arrow-left",
	ARROWS_ARROW_RIGHT: "arrows.arrow-right",
	ARROWS_CHEVRON_DOWN: "arrows.chevron-down",
	ARROWS_CHEVRON_LEFT: "arrows.chevron-left",
	ARROWS_CHEVRON_RIGHT: "arrows.chevron-right",
	ARROWS_TRENDING_UP: "arrows.trending-up",
	BUSINESS_CALENDAR: "business.calendar",
	CLOUD_AND_WEB_TWO_COLUMNS: "cloud-and-web.two-columns",
	CONTENT_SHORT_TEXT: "content.short-text",
	FILE_AND_FOLDER_ADD_DOCUMENT: "file-and-folder.add-document",
	FILE_AND_FOLDER_ADD_FILE: "file-and-folder.add-file",
	FILE_AND_FOLDER_ADD_FOLDER: "file-and-folder.add-folder",
	FILE_AND_FOLDER_ARCHIVE: "file-and-folder.archive",
	FILE_AND_FOLDER_DOCUMENT: "file-and-folder.document",
	FILE_AND_FOLDER_RESTORE: "file-and-folder.restore",
	MEDICAL_ADD_BOOK: "medical.add-book",
	MEDICAL_AMBULANCE: "medical.ambulance",
	MEDICAL_MEDICINE: "medical.medicine",
	MEDICAL_PULSE: "medical.pulse",
	MEDICAL_STETHOSCOPE: "medical.stethoscope",
	PHOTOGRAPHY_TOOLS_EYE: "photography-tools.eye",
	PHOTOGRAPHY_TOOLS_FOCUS: "photography-tools.focus",
	SECURITY_LOCK: "security.lock",
	SECURITY_SHIELD: "security.shield",
	SIGN_AND_SYMBOL_BLOCK: "sign-and-symbol.block",
	USER_INTERFACE_CHECKMARK_CIRCLE: "user-interface.checkmark-circle",
	USER_INTERFACE_CHECKMARK: "user-interface.checkmark",
	USER_INTERFACE_CLOSE_BOLD: "user-interface.close-bold",
	USER_INTERFACE_CLOSE_CIRCLE: "user-interface.close-circle",
	USER_INTERFACE_CLOSE: "user-interface.close",
	USER_INTERFACE_COPY: "user-interface.copy",
	USER_INTERFACE_DISLIKE: "user-interface.dislike",
	USER_INTERFACE_ELLIPSIS_HORIZONTAL: "user-interface.ellipsis-horizontal",
	USER_INTERFACE_EXCLAMATION_MARK_CIRCLE: "user-interface.exclamation-mark-circle",
	USER_INTERFACE_EXCLAMATION_MARK_TRIANGLE: "user-interface.exclamation-mark-triangle",
	USER_INTERFACE_HOUSE: "user-interface.house",
	USER_INTERFACE_LIKE: "user-interface.like",
	USER_INTERFACE_MAGNIFIER: "user-interface.magnifier",
	USER_INTERFACE_MOVE: "user-interface.move",
	USER_INTERFACE_PAPER_PLANE: "user-interface.paper-plane",
	USER_INTERFACE_PEN: "user-interface.pen",
	USER_INTERFACE_PENCIL: "user-interface.pencil",
	USER_INTERFACE_PLUS: "user-interface.plus",
	USER_INTERFACE_SETTING: "user-interface.setting",
	USER_INTERFACE_TRASH: "user-interface.trash"
}, Se = {
	text: "text",
	check: "check"
}, Ce = (e) => {
	let { children: t, selected: n = !1, selectedIndicator: r = Se.text, description: s, icon: c } = e, l = r === Se.check, u = s !== void 0, d = (0, L.default)("menu-item", {
		"menu-item--selected": n,
		"menu-item--detailed": u,
		"menu-item--check": l
	}), f = /* @__PURE__ */ o(i, { children: [
		c === void 0 ? null : /* @__PURE__ */ a("span", {
			className: "menu-item-icon",
			children: /* @__PURE__ */ a(k, {
				name: c,
				size: 16,
				color: D.inherit
			})
		}),
		/* @__PURE__ */ o("span", {
			className: "menu-item-body",
			children: [/* @__PURE__ */ a("span", {
				className: "menu-item-title",
				children: t
			}), u ? /* @__PURE__ */ a("span", {
				className: "menu-item-description",
				children: s
			}) : null]
		}),
		n && l ? /* @__PURE__ */ a(k, {
			name: R.USER_INTERFACE_CHECKMARK,
			size: 12,
			ariaLabel: "Selected"
		}) : null
	] }), p = n ? "true" : void 0;
	if (typeof e.to == "string") {
		let t = {
			className: d,
			role: "menuitem",
			"aria-current": p,
			children: f
		};
		return e.renderItem === void 0 ? /* @__PURE__ */ a("a", {
			...t,
			href: e.to
		}) : e.renderItem(t);
	}
	return /* @__PURE__ */ a("button", {
		type: "button",
		role: "menuitem",
		className: d,
		"aria-current": p,
		onClick: e.onSelect,
		children: f
	});
}, we = (e) => {
	let t = e.trim();
	if (t === "") return "";
	let n = t.indexOf(","), r = (n === -1 ? t : `${t.slice(n + 1).trim()} ${t.slice(0, n).trim()}`.trim()).split(/\s+/).filter(Boolean);
	if (r.length === 0) return "";
	let i = r[0].endsWith(".") && r.length > 1 ? r.slice(1) : r, a = i.length >= 2 ? i : r;
	return (a.length >= 2 ? a[0][0] + a[a.length - 1][0] : a[0].slice(0, 2)).toUpperCase();
}, Te = {
	small: "small",
	medium: "medium",
	large: "large"
}, Ee = {
	violet: "violet",
	blue: "blue",
	lilac: "lilac",
	yellow: "yellow",
	red: "red",
	green: "green",
	grey: "grey"
}, De = (e) => {
	let { name: t, size: n = Te.medium, color: r = Ee.violet, className: i, ...o } = e, s = we(t), c = t.trim() !== "", l = [
		"avatar",
		`avatar-size-${n}`,
		`avatar-color-${r}`,
		i
	].filter(Boolean).join(" ");
	return /* @__PURE__ */ a("span", {
		className: l,
		role: "img",
		"aria-label": c ? t : void 0,
		...o,
		children: /* @__PURE__ */ a("span", {
			className: "avatar-initials",
			"aria-hidden": "true",
			children: s
		})
	});
}, Oe = ({ value: e, onChange: t, onClear: n, label: r, placeholderText: i, disabled: s, ...c }) => {
	let l = d(), u = m(null), f = e.length > 0, p = (e) => {
		t(e.target.value);
	}, h = () => {
		n(), u.current?.focus();
	};
	return /* @__PURE__ */ o("div", {
		className: "search-input-field",
		children: [
			/* @__PURE__ */ a("label", {
				className: "search-input-icon",
				htmlFor: l,
				children: /* @__PURE__ */ a(k, {
					color: "grey",
					name: R.USER_INTERFACE_MAGNIFIER,
					size: 18
				})
			}),
			/* @__PURE__ */ a("input", {
				...c,
				"aria-label": r,
				className: "search-input-control",
				disabled: s,
				id: l,
				onChange: p,
				placeholder: i,
				ref: u,
				type: "search",
				value: e
			}),
			f ? /* @__PURE__ */ a("button", {
				"aria-label": "Clear search",
				className: "search-input-clear",
				disabled: s,
				onClick: h,
				type: "button",
				children: /* @__PURE__ */ a(k, {
					color: "grey",
					name: R.USER_INTERFACE_CLOSE,
					size: 16
				})
			}) : null
		]
	});
}, ke = (e) => `--filterable-select-${e.replace(/[^a-zA-Z0-9]/g, "")}`, Ae = typeof CSS < "u" && typeof CSS.supports == "function" && CSS.supports("anchor-name: --filterable-select"), je = (e, t) => {
	if (!t) return e;
	let n = e.toLowerCase().indexOf(t.toLowerCase());
	return n < 0 ? e : /* @__PURE__ */ o(i, { children: [
		e.slice(0, n),
		/* @__PURE__ */ a("mark", {
			className: "filterable-select-match",
			children: e.slice(n, n + t.length)
		}),
		e.slice(n + t.length)
	] });
}, Me = (e) => {
	let { options: t, onSelect: n, label: r, triggerText: s, value: c, disabled: l = !1, filterPlaceholder: g = "Filter", noResultsText: _ = (e) => `No match for “${e}”.`, align: v = "start", triggerClassName: y, onOpenChange: b } = e, [x, S] = h(!1), [C, w] = h(""), [T, E] = h(-1), D = m(null), O = m(null), A = m(null), j = d(), M = d(), N = ke(d()), P = d(), F = p(() => {
		let e = C.trim().toLowerCase();
		return e ? t.filter((t) => t.name.toLowerCase().includes(e)) : t;
	}, [t, C]), I = T >= 0 ? F[T] : void 0, ee = t.find((e) => e.id === c), te = l || t.length === 0;
	u(() => {
		let e = O.current;
		if (!e) return;
		let t = (e) => {
			let t = e.newState === "open";
			S(t), b?.(t), t && (w(""), E(-1));
		};
		return e.addEventListener("toggle", t), () => {
			e.removeEventListener("toggle", t);
		};
	}, [b]);
	let ne = I ?? ee;
	u(() => {
		x && ne && A.current?.querySelector(`#${CSS.escape(`${P}-${ne.id}`)}`)?.scrollIntoView({ block: "nearest" });
	}, [
		x,
		ne,
		P
	]), f(() => {
		if (!x || Ae) return;
		let e = O.current, t = D.current;
		if (!e || !t) return;
		let n = () => {
			let n = t.getBoundingClientRect();
			e.style.minWidth = `${n.width}px`, e.style.top = `${n.bottom + 6}px`, v === "end" ? e.style.left = `${n.right - e.offsetWidth}px` : e.style.left = `${n.left}px`;
		};
		return n(), window.addEventListener("scroll", n, !0), window.addEventListener("resize", n), () => {
			window.removeEventListener("scroll", n, !0), window.removeEventListener("resize", n);
		};
	}, [x, v]);
	let re = (e) => {
		O.current?.hidePopover(), n(e);
	}, ie = (e) => {
		w(e), E(e.trim() ? 0 : -1);
	};
	return /* @__PURE__ */ o("div", {
		className: "filterable-select",
		children: [/* @__PURE__ */ o("button", {
			ref: D,
			type: "button",
			className: (0, L.default)("filterable-select-trigger", y),
			style: { anchorName: N },
			"aria-label": `${r}: ${ee?.name ?? s}`,
			"aria-haspopup": "dialog",
			"aria-expanded": x,
			"aria-controls": j,
			disabled: te,
			popoverTarget: j,
			children: [/* @__PURE__ */ a("span", {
				className: (0, L.default)("filterable-select-trigger-text", { "filterable-select-trigger-text--placeholder": !ee }),
				children: ee?.name ?? s
			}), /* @__PURE__ */ a("span", {
				className: "filterable-select-chevron",
				children: /* @__PURE__ */ a(k, {
					color: "grey",
					name: R.ARROWS_CHEVRON_DOWN,
					size: 20
				})
			})]
		}), /* @__PURE__ */ a("div", {
			ref: O,
			id: j,
			popover: "auto",
			role: "dialog",
			"aria-label": r,
			className: (0, L.default)("filterable-select-popup", `filterable-select-popup--${v}`),
			style: { positionAnchor: N },
			children: x ? /* @__PURE__ */ o(i, { children: [
				/* @__PURE__ */ a("div", {
					className: "filterable-select-filter",
					children: /* @__PURE__ */ a(Oe, {
						"aria-activedescendant": I ? `${P}-${I.id}` : void 0,
						"aria-autocomplete": "list",
						"aria-controls": M,
						"aria-expanded": !0,
						autoFocus: !0,
						label: g,
						onChange: ie,
						onClear: () => ie(""),
						onKeyDown: (e) => {
							e.key === "Escape" ? (e.preventDefault(), O.current?.hidePopover()) : e.key === "Tab" ? O.current?.hidePopover() : e.key === "Enter" ? (e.preventDefault(), I && re(I)) : F.length !== 0 && (e.key === "ArrowDown" ? (e.preventDefault(), E((e) => (e + 1) % F.length)) : e.key === "ArrowUp" ? (e.preventDefault(), E((e) => (e <= 0 ? F.length : e) - 1)) : e.key === "Home" ? (e.preventDefault(), E(0)) : e.key === "End" && (e.preventDefault(), E(F.length - 1)));
						},
						placeholderText: g,
						role: "combobox",
						value: C
					})
				}),
				/* @__PURE__ */ a("div", {
					ref: A,
					id: M,
					role: "listbox",
					"aria-label": r,
					className: "filterable-select-list",
					children: F.map((e, t) => /* @__PURE__ */ o("button", {
						id: `${P}-${e.id}`,
						type: "button",
						role: "option",
						"aria-label": e.name,
						"aria-selected": e.id === c,
						className: (0, L.default)("filterable-select-option", {
							"filterable-select-option--active": t === T,
							"filterable-select-option--selected": e.id === c
						}),
						onMouseDown: (e) => e.preventDefault(),
						onClick: () => re(e),
						onMouseEnter: () => E(t),
						tabIndex: -1,
						children: [/* @__PURE__ */ a("span", {
							className: "filterable-select-option-label",
							children: je(e.name, C.trim())
						}), e.id === c ? /* @__PURE__ */ a("span", {
							className: "filterable-select-check",
							children: /* @__PURE__ */ a(k, {
								name: R.USER_INTERFACE_CHECKMARK,
								size: 16
							})
						}) : null]
					}, e.id))
				}),
				/* @__PURE__ */ a("output", {
					"aria-live": "polite",
					className: "filterable-select-status",
					children: F.length === 0 ? _(C.trim()) : `${F.length} ${F.length === 1 ? "result" : "results"}`
				})
			] }) : null
		})]
	});
}, z = {
	default: "default",
	error: "error",
	disabled: "disabled",
	readOnly: "readOnly"
}, Ne = {
	standard: "standard",
	small: "small",
	mini: "mini"
}, Pe = {
	singleline: 558,
	multiline: 542,
	mini: 400
}, Fe = (e) => ({
	disabled: e === z.disabled,
	readOnly: e === z.readOnly,
	ariaInvalid: e === z.error || void 0
}), Ie = ({ multiline: e, size: t }) => e ? Pe.multiline : t === Ne.mini ? Pe.mini : Pe.singleline, Le = ({ state: e, showHelperText: t, helperText: n, errorMessage: r }) => e === z.error && r ? {
	text: r,
	icon: R.USER_INTERFACE_EXCLAMATION_MARK_TRIANGLE,
	isError: !0
} : t && n ? {
	text: n,
	icon: R.USER_INTERFACE_EXCLAMATION_MARK_CIRCLE,
	isError: !1
} : null, Re = ({ state: e = z.default, size: t = Ne.standard, showLabel: n = !1, label: r, placeholderText: i, showHelperText: s = !1, helperText: c, errorMessage: l, maxWidth: u, containerStyle: f, multiline: p = !1, ...m }) => {
	let h = d(), g = Le({
		state: e,
		showHelperText: s,
		helperText: c,
		errorMessage: l
	}), _ = g ? `${h}-helper` : void 0, v = [m["aria-describedby"], _].filter(Boolean).join(" "), { disabled: y, readOnly: b, ariaInvalid: x } = Fe(e), S = u ?? Ie({
		multiline: p,
		size: t
	}), C = t !== Ne.mini && n && !!r, w = [
		"text-input-root",
		`state-${e}`,
		`size-${t}`,
		...p ? ["multiline"] : ["singleline"]
	].join(" "), T = [
		"text-input-field",
		`state-${e}`,
		`size-${t}`
	].join(" "), E = g ? ["text-input-helper", g.isError ? "text-input-helper-error" : "text-input-helper-default"].join(" ") : void 0;
	return /* @__PURE__ */ o("div", {
		className: w,
		"data-state": e,
		style: {
			maxWidth: S,
			...f
		},
		children: [
			C ? /* @__PURE__ */ a("label", {
				className: "text-input-label",
				htmlFor: h,
				children: r
			}) : null,
			a(p ? "textarea" : "input", {
				...m,
				"aria-describedby": v || void 0,
				"aria-invalid": x,
				className: T,
				disabled: y,
				id: h,
				placeholder: i,
				readOnly: b
			}),
			g ? /* @__PURE__ */ o("div", {
				className: E,
				id: _,
				children: [/* @__PURE__ */ a(k, {
					name: g.icon,
					size: 16
				}), /* @__PURE__ */ a("span", { children: g.text })]
			}) : null
		]
	});
};
// node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function ze() {
	return typeof window < "u";
}
function Be(e) {
	return Ve(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function B(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function V(e) {
	return ((Ve(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Ve(e) {
	return ze() ? e instanceof Node || e instanceof B(e).Node : !1;
}
function H(e) {
	return ze() ? e instanceof Element || e instanceof B(e).Element : !1;
}
function U(e) {
	return ze() ? e instanceof HTMLElement || e instanceof B(e).HTMLElement : !1;
}
function He(e) {
	return !ze() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof B(e).ShadowRoot;
}
function Ue(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = G(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function We(e) {
	return /^(table|td|th)$/.test(Be(e));
}
function Ge(e) {
	try {
		if (e.matches(":popover-open")) return !0;
	} catch {}
	try {
		return e.matches(":modal");
	} catch {
		return !1;
	}
}
var Ke = /transform|translate|scale|rotate|perspective|filter/, qe = /paint|layout|strict|content/, W = (e) => !!e && e !== "none", Je;
function Ye(e) {
	let t = H(e) ? G(e) : e;
	return W(t.transform) || W(t.translate) || W(t.scale) || W(t.rotate) || W(t.perspective) || !Ze() && (W(t.backdropFilter) || W(t.filter)) || Ke.test(t.willChange || "") || qe.test(t.contain || "");
}
function Xe(e) {
	let t = K(e);
	for (; U(t) && !Qe(t);) {
		if (Ye(t)) return t;
		if (Ge(t)) return null;
		t = K(t);
	}
	return null;
}
function Ze() {
	return Je ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), Je;
}
function Qe(e) {
	return /^(html|body|#document)$/.test(Be(e));
}
function G(e) {
	return B(e).getComputedStyle(e);
}
function $e(e) {
	return H(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function K(e) {
	if (Be(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || He(e) && e.host || V(e);
	return He(t) ? t.host : t;
}
function et(e) {
	let t = K(e);
	return Qe(t) ? (e.ownerDocument || e).body : U(t) && Ue(t) ? t : et(t);
}
function tt(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = et(e), i = r === e.ownerDocument?.body, a = B(r);
	if (i) {
		let e = nt(a);
		return t.concat(a, a.visualViewport || [], Ue(r) ? r : [], e && n ? tt(e) : []);
	}
	return t.concat(r, tt(r, [], n));
}
function nt(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
// node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var rt = Math.min, q = Math.max, it = Math.round, at = Math.floor, J = (e) => ({
	x: e,
	y: e
}), ot = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function st(e, t, n) {
	return q(e, rt(t, n));
}
function ct(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function lt(e) {
	return e.split("-")[0];
}
function ut(e) {
	return e.split("-")[1];
}
function dt(e) {
	return e === "x" ? "y" : "x";
}
function ft(e) {
	return e === "y" ? "height" : "width";
}
function Y(e) {
	let t = e[0];
	return t === "t" || t === "b" ? "y" : "x";
}
function pt(e) {
	return dt(Y(e));
}
function mt(e, t, n) {
	n === void 0 && (n = !1);
	let r = ut(e), i = pt(e), a = ft(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = Ct(o)), [o, Ct(o)];
}
function ht(e) {
	let t = Ct(e);
	return [
		gt(e),
		t,
		gt(t)
	];
}
function gt(e) {
	return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var _t = ["left", "right"], vt = ["right", "left"], yt = ["top", "bottom"], bt = ["bottom", "top"];
function xt(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? vt : _t : t ? _t : vt;
		case "left":
		case "right": return t ? yt : bt;
		default: return [];
	}
}
function St(e, t, n, r) {
	let i = ut(e), a = xt(lt(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(gt)))), a;
}
function Ct(e) {
	let t = lt(e);
	return ot[t] + e.slice(t.length);
}
function wt(e) {
	return {
		top: e.top ?? 0,
		right: e.right ?? 0,
		bottom: e.bottom ?? 0,
		left: e.left ?? 0
	};
}
function Tt(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : wt(e);
}
function Et(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
var Dt = "input:not([inert]):not([inert] *),select:not([inert]):not([inert] *),textarea:not([inert]):not([inert] *),a[href]:not([inert]):not([inert] *),area[href]:not([inert]):not([inert] *),button:not([inert]):not([inert] *),[tabindex]:not(slot):not([inert]):not([inert] *),audio[controls]:not([inert]):not([inert] *),video[controls]:not([inert]):not([inert] *),[contenteditable]:not([contenteditable=\"false\"]):not([inert]):not([inert] *),details>summary:first-of-type:not([inert]):not([inert] *),details:not([inert]):not([inert] *)", Ot = typeof Element > "u", kt = Ot ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, At = !Ot && Element.prototype.getRootNode ? function(e) {
	return e?.getRootNode?.call(e);
} : function(e) {
	return e?.ownerDocument;
}, jt = function(e, t) {
	t === void 0 && (t = !0);
	var n = e?.getAttribute?.call(e, "inert");
	return n === "" || n === "true" || t && e && (typeof e.closest == "function" ? e.closest("[inert]") : jt(e.parentNode));
}, Mt = function(e) {
	var t = e?.getAttribute?.call(e, "contenteditable");
	return t === "" || t === "true";
}, Nt = function(e, t, n) {
	if (jt(e)) return [];
	var r = Array.prototype.slice.apply(e.querySelectorAll(Dt));
	return t && kt.call(e, Dt) && r.unshift(e), r = r.filter(n), r;
}, Pt = function(e, t, n) {
	for (var r = [], i = Array.from(e); i.length;) {
		var a = i.shift();
		if (!jt(a, !1)) {
			if (a.tagName === "SLOT") {
				var o = a.assignedElements(), s = Pt(o.length ? o : a.children, !0, n);
				n.flatten ? r.push.apply(r, s) : r.push({
					scopeParent: a,
					candidates: s
				});
			} else {
				kt.call(a, Dt) && n.filter(a) && (t || !e.includes(a)) && r.push(a);
				var c = a.shadowRoot || typeof n.getShadowRoot == "function" && n.getShadowRoot(a), l = !jt(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(a));
				if (c && l) {
					var u = Pt(c === !0 ? a.children : c.children, !0, n);
					n.flatten ? r.push.apply(r, u) : r.push({
						scopeParent: a,
						candidates: u
					});
				} else i.unshift.apply(i, a.children);
			}
		}
	}
	return r;
}, Ft = function(e) {
	return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, It = function(e) {
	if (!e) throw Error("No node provided");
	return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || Mt(e)) && !Ft(e) ? 0 : e.tabIndex;
}, Lt = function(e, t) {
	var n = It(e);
	return n < 0 && t && !Ft(e) ? 0 : n;
}, Rt = function(e, t) {
	return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, zt = function(e) {
	return e.tagName === "INPUT";
}, Bt = function(e) {
	return zt(e) && e.type === "hidden";
}, Vt = function(e) {
	return e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(e) {
		return e.tagName === "SUMMARY";
	});
}, Ht = function(e, t) {
	for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === t) return e[n];
}, Ut = function(e) {
	if (!e.name) return !0;
	var t = e.form || At(e), n = function(e) {
		return t.querySelectorAll("input[type=\"radio\"][name=\"" + e + "\"]");
	}, r;
	if (typeof window < "u" && window.CSS !== void 0 && typeof window.CSS.escape == "function") r = n(window.CSS.escape(e.name));
	else try {
		r = n(e.name);
	} catch (e) {
		return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
	}
	var i = Ht(r, e.form);
	return !i || i === e;
}, Wt = function(e) {
	return zt(e) && e.type === "radio";
}, Gt = function(e) {
	return Wt(e) && !Ut(e);
}, Kt = function(e) {
	var t = e && At(e), n = t?.host, r = !1;
	if (t && t !== e) {
		var i, a, o;
		for (r = !!((i = n) != null && (a = i.ownerDocument) != null && a.contains(n) || e != null && (o = e.ownerDocument) != null && o.contains(e)); !r && n;) {
			var s, c;
			t = At(n), n = t?.host, r = !!((s = n) != null && (c = s.ownerDocument) != null && c.contains(n));
		}
	}
	return r;
}, qt = function(e) {
	var t = e.getBoundingClientRect(), n = t.width, r = t.height;
	return n === 0 && r === 0;
}, Jt = function(e, t) {
	var n = t.displayCheck, r = t.getShadowRoot;
	if (n === "full-native" && "checkVisibility" in e) return !e.checkVisibility({
		checkOpacity: !1,
		opacityProperty: !1,
		contentVisibilityAuto: !0,
		visibilityProperty: !0,
		checkVisibilityCSS: !0
	});
	var i = getComputedStyle(e).visibility;
	if (i === "hidden" || i === "collapse") return !0;
	var a = kt.call(e, "details>summary:first-of-type") ? e.parentElement : e;
	if (kt.call(a, "details:not([open]) *")) return !0;
	if (!n || n === "full" || n === "full-native" || n === "legacy-full") {
		if (typeof r == "function") {
			for (var o = e; e;) {
				var s = e.parentElement, c = At(e);
				if (s && !s.shadowRoot && r(s) === !0) return qt(e);
				e = e.assignedSlot ? e.assignedSlot : !s && c !== e.ownerDocument ? c.host : s;
			}
			e = o;
		}
		if (Kt(e)) return !e.getClientRects().length;
		if (n !== "legacy-full") return !0;
	} else if (n === "non-zero-area") return qt(e);
	return !1;
}, Yt = function(e) {
	if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var t = e.parentElement; t;) {
		if (t.tagName === "FIELDSET" && t.disabled) {
			for (var n = 0; n < t.children.length; n++) {
				var r = t.children.item(n);
				if (r.tagName === "LEGEND") return kt.call(t, "fieldset[disabled] *") ? !0 : !r.contains(e);
			}
			return !0;
		}
		t = t.parentElement;
	}
	return !1;
}, Xt = function(e, t) {
	return !(t.disabled || Bt(t) || Jt(t, e) || Vt(t) || Yt(t));
}, Zt = function(e, t) {
	return !(Gt(t) || It(t) < 0 || !Xt(e, t));
}, Qt = function(e) {
	var t = parseInt(e.getAttribute("tabindex"), 10);
	return !!(isNaN(t) || t >= 0);
}, $t = function(e) {
	var t = [], n = [];
	return e.forEach(function(e, r) {
		var i = !!e.scopeParent, a = i ? e.scopeParent : e, o = Lt(a, i), s = i ? $t(e.candidates) : a;
		o === 0 ? i ? t.push.apply(t, s) : t.push(a) : n.push({
			documentOrder: r,
			tabIndex: o,
			item: e,
			isScope: i,
			content: s
		});
	}), n.sort(Rt).reduce(function(e, t) {
		return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
	}, []).concat(t);
}, en = function(e, t) {
	return t ||= {}, $t(t.getShadowRoot ? Pt([e], t.includeContainer, {
		filter: Zt.bind(null, t),
		flatten: !1,
		getShadowRoot: t.getShadowRoot,
		shadowRootFilter: Qt
	}) : Nt(e, t.includeContainer, Zt.bind(null, t)));
};
// node_modules/.pnpm/@floating-ui+react@0.27.20_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs
function tn() {
	let e = navigator.userAgentData;
	return e != null && e.platform ? e.platform : navigator.platform;
}
function nn() {
	let e = navigator.userAgentData;
	return e && Array.isArray(e.brands) ? e.brands.map((e) => {
		let { brand: t, version: n } = e;
		return t + "/" + n;
	}).join(" ") : navigator.userAgent;
}
function rn() {
	return /apple/i.test(navigator.vendor);
}
function an() {
	return tn().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function on() {
	return nn().includes("jsdom/");
}
var sn = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function cn(e) {
	let t = e.activeElement;
	for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null;) {
		var n;
		t = t.shadowRoot.activeElement;
	}
	return t;
}
function ln(e, t) {
	if (!e || !t) return !1;
	let n = t.getRootNode == null ? void 0 : t.getRootNode();
	if (e.contains(t)) return !0;
	if (n && He(n)) {
		let n = t;
		for (; n;) {
			if (e === n) return !0;
			n = n.parentNode || n.host;
		}
	}
	return !1;
}
function un(e) {
	return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function X(e) {
	return e?.ownerDocument || document;
}
function dn(e) {
	return U(e) && e.matches(sn);
}
function fn(e) {
	if (!e || on()) return !0;
	try {
		return e.matches(":focus-visible");
	} catch {
		return !0;
	}
}
function pn(e, t) {
	let n = ["mouse", "pen"];
	return t || n.push("", void 0), n.includes(e);
}
var Z = typeof document < "u" ? f : function() {}, mn = { ...s };
function hn(e) {
	let t = s.useRef(e);
	return Z(() => {
		t.current = e;
	}), t;
}
var gn = mn.useInsertionEffect || ((e) => e());
function _n(e) {
	let t = s.useRef(() => {
		if (process.env.NODE_ENV !== "production") throw Error("Cannot call an event handler while rendering.");
	});
	return gn(() => {
		t.current = e;
	}), s.useCallback(function() {
		var e = [...arguments];
		return t.current == null ? void 0 : t.current(...e);
	}, []);
}
var vn = () => ({
	getShadowRoot: !0,
	displayCheck: typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
});
function yn(e, t) {
	let n = en(e, vn()), r = n.length;
	if (r === 0) return;
	let i = cn(X(e)), a = n.indexOf(i);
	return n[a === -1 ? t === 1 ? 0 : r - 1 : a + t];
}
function bn(e) {
	return yn(X(e).body, 1) || e;
}
function xn(e) {
	return yn(X(e).body, -1) || e;
}
function Sn(e, t) {
	let n = t || e.currentTarget, r = e.relatedTarget;
	return !r || !ln(n, r);
}
function Cn(e) {
	en(e, vn()).forEach((e) => {
		e.dataset.tabindex = e.getAttribute("tabindex") || "", e.setAttribute("tabindex", "-1");
	});
}
function wn(e) {
	e.querySelectorAll("[data-tabindex]").forEach((e) => {
		let t = e.dataset.tabindex;
		delete e.dataset.tabindex, t ? e.setAttribute("tabindex", t) : e.removeAttribute("tabindex");
	});
}
// node_modules/.pnpm/@floating-ui+core@1.8.0/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Tn(e, t, n) {
	let { reference: r, floating: i } = e, a = Y(t), o = pt(t), s = ft(o), c = lt(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	let m = ut(t);
	return m && (p[o] += f * (m === "end" ? 1 : -1) * (n && l ? -1 : 1)), p;
}
async function En(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = ct(t, e), p = Tt(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Et(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Et(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Dn = 50, On = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = o.detectOverflow ? o : {
		...o,
		detectOverflow: En
	}, c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Tn(l, r, c), f = r, p = 0, m = {};
	for (let n = 0; n < a.length; n++) {
		let h = a[n];
		if (!h) continue;
		let { name: g, fn: _ } = h, { x: v, y, data: b, reset: x } = await _({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: m,
			rects: l,
			platform: s,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = v ?? u, d = y ?? d, m[g] = {
			...m[g],
			...b
		}, x && p < Dn && (p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : x.rects), {x: u, y: d} = Tn(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: m
	};
}, kn = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = ct(e, t) || {};
		if (l == null) return {};
		let d = Tt(u), f = {
			x: n,
			y: r
		}, p = pt(i), m = ft(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		C && await (o.isElement == null ? void 0 : o.isElement(S)) || (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = rt(d[_], T), D = rt(d[v], T), O = C - h[m] - D, k = C / 2 - h[m] / 2 + w, A = st(E, k, O), j = !c.arrow && ut(i) != null && k !== A && a.reference[m] / 2 - (k < E ? E : D) - h[m] / 2 < 0, M = j ? k < E ? k - E : k - O : 0;
		return {
			[p]: f[p] + M,
			data: {
				[p]: A,
				centerOffset: k - A - M,
				...j && { alignmentOffset: M }
			},
			reset: j
		};
	}
}), An = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = ct(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = lt(r), _ = Y(o), v = lt(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [Ct(o)] : ht(o)), x = p !== "none";
			!d && x && b.push(...St(o, m, p, y));
			let S = [o, ...b], C = await s.detectOverflow(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = mt(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (u !== "alignment" || _ === Y(t) || T.every((e) => Y(e.placement) !== _ || e.overflows[0] > 0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = Y(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement": n = o;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
}, jn = /*#__PURE__*/ new Set(["left", "top"]);
async function Mn(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = lt(n), s = ut(n), c = Y(n) === "y", l = jn.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = ct(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Nn = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Mn(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, Pn = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i, platform: a } = t, { mainAxis: o = !0, crossAxis: s = !1, limiter: c = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...l } = ct(e, t), u = {
				x: n,
				y: r
			}, d = await a.detectOverflow(t, l), f = Y(i), p = dt(f), m = u[p], h = u[f], g = (e, t) => st(t + d[e === "y" ? "top" : "left"], t, t - d[e === "y" ? "bottom" : "right"]);
			o && (m = g(p, m)), s && (h = g(f, h));
			let _ = c.fn({
				...t,
				[p]: m,
				[f]: h
			});
			return {
				..._,
				data: {
					x: _.x - n,
					y: _.y - r,
					enabled: {
						[p]: o,
						[f]: s
					}
				}
			};
		}
	};
};
// node_modules/.pnpm/@floating-ui+dom@1.8.0/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function Fn(e) {
	let t = G(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = U(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = it(n) !== a || it(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function In(e) {
	return H(e) ? e : e.contextElement;
}
function Ln(e) {
	let t = In(e);
	if (!U(t)) return J(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = Fn(t), o = (a ? it(n.width) : n.width) / r, s = (a ? it(n.height) : n.height) / i;
	return o && Number.isFinite(o) || (o = 1), s && Number.isFinite(s) || (s = 1), {
		x: o,
		y: s
	};
}
var Rn = /*#__PURE__*/ J(0);
function zn(e) {
	let t = B(e);
	return !Ze() || !t.visualViewport ? Rn : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function Bn(e, t, n) {
	return t === void 0 && (t = !1), !!n && t && n === B(e);
}
function Q(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = In(e), o = J(1);
	t && (r ? H(r) && (o = Ln(r)) : o = Ln(e));
	let s = Bn(a, n, r) ? zn(a) : J(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a && r) {
		let e = B(a), t = H(r) ? B(r) : r, n = e, i = nt(n);
		for (; i && t !== n;) {
			let e = Ln(i), t = i.getBoundingClientRect(), r = G(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = B(i), i = nt(n);
		}
	}
	return Et({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function Vn(e, t) {
	let n = $e(e).scrollLeft;
	return t ? t.left + n : Q(V(e)).left + n;
}
function Hn(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - Vn(e, n),
		y: n.top + t.scrollTop
	};
}
function Un(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = V(r), s = t ? Ge(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = J(1), u = J(0), d = U(r);
	if ((d || !a) && ((Be(r) !== "body" || Ue(o)) && (c = $e(r)), d)) {
		let e = Q(r);
		l = Ln(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? Hn(o, c) : J(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function Wn(e) {
	return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function Gn(e) {
	let t = $e(e), n = e.ownerDocument.body, r = q(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = q(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight), a = -t.scrollLeft + Vn(e), o = -t.scrollTop;
	return G(n).direction === "rtl" && (a += q(e.clientWidth, n.clientWidth) - r), {
		width: r,
		height: i,
		x: a,
		y: o
	};
}
var Kn = 25;
function qn(e, t, n) {
	n === void 0 && (n = "viewport");
	let r = n === "layoutViewport", i = B(e), a = V(e), o = i.visualViewport, s = a.clientWidth, c = a.clientHeight, l = 0, u = 0;
	if (o) {
		let e = !Ze() || t === "fixed";
		r ? e || (l = -o.offsetLeft, u = -o.offsetTop) : (s = o.width, c = o.height, e && (l = o.offsetLeft, u = o.offsetTop));
	}
	if (Vn(a) <= 0) {
		let e = a.ownerDocument, t = e.body, n = getComputedStyle(t), r = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, i = Math.abs(a.clientWidth - t.clientWidth - r), o = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? i / 2 : i;
		o <= Kn && (s -= o);
	}
	return {
		width: s,
		height: c,
		x: l,
		y: u
	};
}
function Jn(e, t) {
	let n = Q(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Ln(e);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function Yn(e, t, n) {
	let r;
	if (t === "viewport" || t === "layoutViewport") r = qn(e, n, t);
	else if (t === "document") r = Gn(V(e));
	else if (H(t)) r = Jn(t, n);
	else {
		let n = zn(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Et(r);
}
function Xn(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = tt(e, [], !1).filter((e) => H(e) && Be(e) !== "body"), i = null, a = G(e).position === "fixed", o = a ? K(e) : e;
	for (; H(o) && !Qe(o);) {
		let e = G(o), t = Ye(o), n = i ? i.position : a ? "fixed" : "";
		!t && (n === "fixed" || n === "absolute" && e.position === "static") ? r = r.filter((e) => e !== o) : i = e, o = K(o);
	}
	return t.set(e, r), r;
}
function Zn(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Ge(t) ? [] : Xn(t, this._c) : [].concat(n), r], o = Yn(t, a[0], i), s = o.top, c = o.right, l = o.bottom, u = o.left;
	for (let e = 1; e < a.length; e++) {
		let n = Yn(t, a[e], i);
		s = q(n.top, s), c = rt(n.right, c), l = rt(n.bottom, l), u = q(n.left, u);
	}
	return {
		width: c - u,
		height: l - s,
		x: u,
		y: s
	};
}
function Qn(e) {
	let { width: t, height: n } = Fn(e);
	return {
		width: t,
		height: n
	};
}
function $n(e, t, n) {
	let r = U(t), i = V(t), a = n === "fixed", o = Q(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = J(0);
	if ((r || !a) && ((Be(t) !== "body" || Ue(i)) && (s = $e(t)), r)) {
		let e = Q(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	}
	!r && i && (c.x = Vn(i));
	let l = i && !r && !a ? Hn(i, s) : J(0);
	return {
		x: o.left + s.scrollLeft - c.x - l.x,
		y: o.top + s.scrollTop - c.y - l.y,
		width: o.width,
		height: o.height
	};
}
function er(e) {
	return G(e).position === "static";
}
function tr(e, t) {
	if (!U(e) || G(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return V(e) === n && (n = n.ownerDocument.body), n;
}
function nr(e, t) {
	let n = B(e);
	if (Ge(e)) return n;
	if (!U(e)) {
		let t = K(e);
		for (; t && !Qe(t);) {
			if (H(t) && !er(t)) return t;
			t = K(t);
		}
		return n;
	}
	let r = tr(e, t);
	for (; r && We(r) && er(r);) r = tr(r, t);
	return r && Qe(r) && er(r) && !Ye(r) ? n : r || Xe(e) || n;
}
var rr = async function(e) {
	let t = this.getOffsetParent || nr, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: $n(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function ir(e) {
	return G(e).direction === "rtl";
}
var ar = {
	convertOffsetParentRelativeRectToViewportRelativeRect: Un,
	getDocumentElement: V,
	getClippingRect: Zn,
	getOffsetParent: nr,
	getElementRects: rr,
	getClientRects: Wn,
	getDimensions: Qn,
	getScale: Ln,
	isElement: H,
	isRTL: ir
};
function or(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function sr(e, t, n) {
	let r = null, i, a = V(e);
	function o() {
		var e;
		clearTimeout(i), (e = r) == null || e.disconnect(), r = null;
	}
	function s(n, c) {
		n === void 0 && (n = !1), c === void 0 && (c = 1), o();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (n || t(), !f || !p) return;
		let m = at(d), h = at(a.clientWidth - (u + f)), g = at(a.clientHeight - (d + p)), _ = at(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: q(0, rt(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (!or(l, e.getBoundingClientRect())) return s();
			if (n !== c) {
				if (!y) return s();
				n ? s(!1, n) : i = setTimeout(() => {
					s(!1, 1e-7);
				}, 1e3);
			}
			y = !1;
		}
		try {
			r = new IntersectionObserver(b, {
				...v,
				root: a.ownerDocument
			});
		} catch {
			r = new IntersectionObserver(b, v);
		}
		r.observe(e);
	}
	let c = B(e), l = () => s(n);
	return c.addEventListener("resize", l), s(!0), () => {
		c.removeEventListener("resize", l), o();
	};
}
function cr(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = In(e), u = i || a ? [...l ? tt(l) : [], ...t ? tt(t) : []] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n), a && e.addEventListener("resize", n);
	});
	let d = l && s ? sr(l, n, a) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && t && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), t && p.observe(t));
	let m, h = c ? Q(e) : null;
	c && g();
	function g() {
		let t = Q(e);
		h && !or(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var lr = Nn, ur = Pn, dr = An, fr = kn, pr = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = n ?? {}, a = {
		...ar,
		...i.platform,
		_c: r
	};
	return On(e, t, {
		...i,
		platform: a
	});
}, mr = typeof document < "u" ? f : function() {};
function hr(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!hr(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !hr(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function gr(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _r(e, t) {
	let n = gr(e);
	return Math.round(t * n) / n;
}
function vr(e) {
	let t = s.useRef(e);
	return mr(() => {
		t.current = e;
	}), t;
}
function yr(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: r = [], platform: i, elements: { reference: a, floating: o } = {}, transform: c = !0, whileElementsMounted: l, open: u } = e, [d, f] = s.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [p, m] = s.useState(r);
	hr(p, r) || m(r);
	let [h, _] = s.useState(null), [v, y] = s.useState(null), b = s.useCallback((e) => {
		e !== w.current && (w.current = e, _(e));
	}, []), x = s.useCallback((e) => {
		e !== T.current && (T.current = e, y(e));
	}, []), S = a || h, C = o || v, w = s.useRef(null), T = s.useRef(null), E = s.useRef(d), D = l != null, O = vr(l), k = vr(i), A = vr(u), j = s.useCallback(() => {
		if (!w.current || !T.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: p
		};
		k.current && (e.platform = k.current), pr(w.current, T.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: A.current !== !1
			};
			M.current && !hr(E.current, t) && (E.current = t, g.flushSync(() => {
				f(t);
			}));
		});
	}, [
		p,
		t,
		n,
		k,
		A
	]);
	mr(() => {
		u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [u]);
	let M = s.useRef(!1);
	mr(() => (M.current = !0, () => {
		M.current = !1;
	}), []), mr(() => {
		if (S && (w.current = S), C && (T.current = C), S && C) {
			if (O.current) return O.current(S, C, j);
			j();
		}
	}, [
		S,
		C,
		j,
		O,
		D
	]);
	let N = s.useMemo(() => ({
		reference: w,
		floating: T,
		setReference: b,
		setFloating: x
	}), [b, x]), P = s.useMemo(() => ({
		reference: S,
		floating: C
	}), [S, C]), F = s.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!P.floating) return e;
		let t = _r(P.floating, d.x), r = _r(P.floating, d.y);
		return c ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...gr(P.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		c,
		P.floating,
		d.x,
		d.y
	]);
	return s.useMemo(() => ({
		...d,
		update: j,
		refs: N,
		elements: P,
		floatingStyles: F
	}), [
		d,
		j,
		N,
		P,
		F
	]);
}
var br = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : fr({
				element: r.current,
				padding: i
			}).fn(n) : r ? fr({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, xr = (e, t) => {
	let n = lr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Sr = (e, t) => {
	let n = ur(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Cr = (e, t) => {
	let n = dr(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, wr = (e, t) => {
	let n = br(e);
	return {
		name: n.name,
		fn: n.fn,
		options: [e, t]
	};
}, Tr = "data-floating-ui-focusable", Er = "active", Dr = "selected", Or = "ArrowLeft", kr = "ArrowRight", Ar = "ArrowUp", jr = "ArrowDown", Mr = [Or, kr], Nr = [Ar, jr];
[...Mr, ...Nr];
var Pr = { ...s }, Fr = !1, Ir = 0, Lr = () => "floating-ui-" + Math.random().toString(36).slice(2, 6) + Ir++;
function Rr() {
	let [e, t] = s.useState(() => Fr ? Lr() : void 0);
	return Z(() => {
		e ?? t(Lr());
	}, []), s.useEffect(() => {
		Fr = !0;
	}, []), e;
}
var zr = Pr.useId || Rr, Br;
process.env.NODE_ENV !== "production" && (Br = /*#__PURE__*/ new Set());
function Vr() {
	var e;
	let t = "Floating UI: " + [...arguments].join(" ");
	if (!((e = Br) != null && e.has(t))) {
		var n;
		(n = Br) == null || n.add(t), console.warn(t);
	}
}
function Hr() {
	var e;
	let t = "Floating UI: " + [...arguments].join(" ");
	if (!((e = Br) != null && e.has(t))) {
		var n;
		(n = Br) == null || n.add(t), console.error(t);
	}
}
var Ur = /*#__PURE__*/ s.forwardRef(function(e, t) {
	let { context: { placement: n, elements: { floating: r }, middlewareData: { arrow: i, shift: c } }, width: l = 14, height: u = 7, tipRadius: d = 0, strokeWidth: f = 0, staticOffset: p, stroke: m, d: h, style: { transform: g, ..._ } = {}, ...v } = e;
	process.env.NODE_ENV !== "production" && (t || Vr("The `ref` prop is required for `FloatingArrow`."));
	let y = zr(), [b, x] = s.useState(!1);
	if (Z(() => {
		r && G(r).direction === "rtl" && x(!0);
	}, [r]), !r) return null;
	let [S, C] = n.split("-"), w = S === "top" || S === "bottom", T = p;
	(w && c != null && c.x || !w && c != null && c.y) && (T = null);
	let E = f * 2, D = E / 2, O = l / 2 * (d / -8 + 1), k = u / 2 * d / 4, A = !!h, j = T && C === "end" ? "bottom" : "top", M = T && C === "end" ? "right" : "left";
	T && b && (M = C === "end" ? "left" : "right");
	let N = i?.x == null ? "" : T || i.x, P = i?.y == null ? "" : T || i.y, F = h || "M0,0" + (" H" + l) + (" L" + (l - O) + "," + (u - k)) + (" Q" + l / 2 + "," + u + " " + O + "," + (u - k)) + " Z", I = {
		top: A ? "rotate(180deg)" : "",
		left: A ? "rotate(90deg)" : "rotate(-90deg)",
		bottom: A ? "" : "rotate(180deg)",
		right: A ? "rotate(-90deg)" : "rotate(90deg)"
	}[S];
	return /*#__PURE__*/ o("svg", {
		...v,
		"aria-hidden": !0,
		ref: t,
		width: A ? l : l + E,
		height: l,
		viewBox: "0 0 " + l + " " + (u > l ? u : l),
		style: {
			position: "absolute",
			pointerEvents: "none",
			[M]: N,
			[j]: P,
			[S]: w || A ? "100%" : "calc(100% - " + E / 2 + "px)",
			transform: [I, g].filter((e) => !!e).join(" "),
			..._
		},
		children: [
			E > 0 && /*#__PURE__*/ a("path", {
				clipPath: "url(#" + y + ")",
				fill: "none",
				stroke: m,
				strokeWidth: E + +!h,
				d: F
			}),
			/*#__PURE__*/ a("path", {
				stroke: E && !h ? v.fill : "none",
				d: F
			}),
			/*#__PURE__*/ a("clipPath", {
				id: y,
				children: /*#__PURE__*/ a("rect", {
					x: -D,
					y: D * (A ? -1 : 1),
					width: l + E,
					height: l
				})
			})
		]
	});
});
function Wr() {
	let e = /* @__PURE__ */ new Map();
	return {
		emit(t, n) {
			var r;
			(r = e.get(t)) == null || r.forEach((e) => e(n));
		},
		on(t, n) {
			e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
		},
		off(t, n) {
			var r;
			(r = e.get(t)) == null || r.delete(n);
		}
	};
}
var Gr = /*#__PURE__*/ s.createContext(null), Kr = /*#__PURE__*/ s.createContext(null), qr = () => s.useContext(Gr)?.id || null, Jr = () => s.useContext(Kr);
function Yr(e) {
	return "data-floating-ui-" + e;
}
function $(e) {
	e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
var Xr = /*#__PURE__*/ Yr("safe-polygon");
function Zr(e, t, n) {
	if (n && !pn(n)) return 0;
	if (typeof e == "number") return e;
	if (typeof e == "function") {
		let n = e();
		return typeof n == "number" ? n : n?.[t];
	}
	return e?.[t];
}
function Qr(e) {
	return typeof e == "function" ? e() : e;
}
function $r(e, t) {
	t === void 0 && (t = {});
	let { open: n, onOpenChange: r, dataRef: i, events: a, elements: o } = e, { enabled: c = !0, delay: l = 0, handleClose: u = null, mouseOnly: d = !1, restMs: f = 0, move: p = !0 } = t, m = Jr(), h = qr(), g = hn(u), _ = hn(l), v = hn(n), y = hn(f), b = s.useRef(), x = s.useRef(-1), S = s.useRef(), C = s.useRef(-1), w = s.useRef(!0), T = s.useRef(!1), E = s.useRef(() => {}), D = s.useRef(!1), O = _n(() => {
		let e = i.current.openEvent?.type;
		return e?.includes("mouse") && e !== "mousedown";
	});
	s.useEffect(() => {
		if (!c) return;
		function e(e) {
			let { open: t } = e;
			t || ($(x), $(C), w.current = !0, D.current = !1);
		}
		return a.on("openchange", e), () => {
			a.off("openchange", e);
		};
	}, [c, a]), s.useEffect(() => {
		if (!c || !g.current || !n) return;
		function e(e) {
			O() && r(!1, e, "hover");
		}
		let t = X(o.floating).documentElement;
		return t.addEventListener("mouseleave", e), () => {
			t.removeEventListener("mouseleave", e);
		};
	}, [
		o.floating,
		n,
		r,
		c,
		g,
		O
	]);
	let k = s.useCallback(function(e, t, n) {
		t === void 0 && (t = !0), n === void 0 && (n = "hover");
		let i = Zr(_.current, "close", b.current);
		i && !S.current ? ($(x), x.current = window.setTimeout(() => r(!1, e, n), i)) : t && ($(x), r(!1, e, n));
	}, [_, r]), A = _n(() => {
		E.current(), S.current = void 0;
	}), j = _n(() => {
		if (T.current) {
			let e = X(o.floating).body;
			e.style.pointerEvents = "", e.removeAttribute(Xr), T.current = !1;
		}
	}), M = _n(() => i.current.openEvent ? ["click", "mousedown"].includes(i.current.openEvent.type) : !1);
	s.useEffect(() => {
		if (!c) return;
		function e(e) {
			if ($(x), w.current = !1, d && !pn(b.current) || Qr(y.current) > 0 && !Zr(_.current, "open")) return;
			let t = Zr(_.current, "open", b.current);
			t ? x.current = window.setTimeout(() => {
				v.current || r(!0, e, "hover");
			}, t) : n || r(!0, e, "hover");
		}
		function t(e) {
			if (M()) {
				j();
				return;
			}
			E.current();
			let t = X(o.floating);
			if ($(C), D.current = !1, g.current && i.current.floatingContext) {
				n || $(x), S.current = g.current({
					...i.current.floatingContext,
					tree: m,
					x: e.clientX,
					y: e.clientY,
					onClose() {
						j(), A(), M() || k(e, !0, "safe-polygon");
					}
				});
				let r = S.current;
				t.addEventListener("mousemove", r), E.current = () => {
					t.removeEventListener("mousemove", r);
				};
			} else b.current === "touch" && ln(o.floating, e.relatedTarget) || k(e);
		}
		function a(e) {
			M() || i.current.floatingContext && (g.current == null || g.current({
				...i.current.floatingContext,
				tree: m,
				x: e.clientX,
				y: e.clientY,
				onClose() {
					j(), A(), M() || k(e);
				}
			})(e));
		}
		function s() {
			$(x);
		}
		function l(e) {
			M() || k(e, !1);
		}
		if (H(o.domReference)) {
			let r = o.domReference, i = o.floating;
			return n && r.addEventListener("mouseleave", a), p && r.addEventListener("mousemove", e, { once: !0 }), r.addEventListener("mouseenter", e), r.addEventListener("mouseleave", t), i && (i.addEventListener("mouseleave", a), i.addEventListener("mouseenter", s), i.addEventListener("mouseleave", l)), () => {
				n && r.removeEventListener("mouseleave", a), p && r.removeEventListener("mousemove", e), r.removeEventListener("mouseenter", e), r.removeEventListener("mouseleave", t), i && (i.removeEventListener("mouseleave", a), i.removeEventListener("mouseenter", s), i.removeEventListener("mouseleave", l));
			};
		}
	}, [
		o,
		c,
		e,
		d,
		p,
		k,
		A,
		j,
		r,
		n,
		v,
		m,
		_,
		g,
		i,
		M,
		y
	]), Z(() => {
		var e;
		if (c && n && (e = g.current) != null && (e = e.__options) != null && e.blockPointerEvents && O()) {
			T.current = !0;
			let e = o.floating;
			if (H(o.domReference) && e) {
				var t;
				let n = X(o.floating).body;
				n.setAttribute(Xr, "");
				let r = o.domReference, i = m == null || (t = m.nodesRef.current.find((e) => e.id === h)) == null || (t = t.context) == null ? void 0 : t.elements.floating;
				return i && (i.style.pointerEvents = ""), n.style.pointerEvents = "none", r.style.pointerEvents = "auto", e.style.pointerEvents = "auto", () => {
					n.style.pointerEvents = "", r.style.pointerEvents = "", e.style.pointerEvents = "";
				};
			}
		}
	}, [
		c,
		n,
		h,
		o,
		m,
		g,
		O
	]), Z(() => {
		n || (b.current = void 0, D.current = !1, A(), j());
	}, [
		n,
		A,
		j
	]), s.useEffect(() => () => {
		A(), $(x), $(C), j();
	}, [
		c,
		o.domReference,
		A,
		j
	]);
	let N = s.useMemo(() => {
		function e(e) {
			b.current = e.pointerType;
		}
		return {
			onPointerDown: e,
			onPointerEnter: e,
			onMouseMove(e) {
				let { nativeEvent: t } = e;
				function i() {
					!w.current && !v.current && r(!0, t, "hover");
				}
				d && !pn(b.current) || n || Qr(y.current) === 0 || D.current && e.movementX ** 2 + e.movementY ** 2 < 2 || ($(C), b.current === "touch" ? i() : (D.current = !0, C.current = window.setTimeout(i, Qr(y.current))));
			}
		};
	}, [
		d,
		r,
		n,
		v,
		y
	]);
	return s.useMemo(() => c ? { reference: N } : {}, [c, N]);
}
var ei = {
	border: 0,
	clip: "rect(0 0 0 0)",
	height: "1px",
	margin: "-1px",
	overflow: "hidden",
	padding: 0,
	position: "fixed",
	whiteSpace: "nowrap",
	width: "1px",
	top: 0,
	left: 0
}, ti = /*#__PURE__*/ s.forwardRef(function(e, t) {
	let [n, r] = s.useState();
	Z(() => {
		rn() && r("button");
	}, []);
	let i = {
		ref: t,
		tabIndex: 0,
		role: n,
		"aria-hidden": !n || void 0,
		[Yr("focus-guard")]: "",
		style: ei
	};
	return /*#__PURE__*/ a("span", {
		...e,
		...i
	});
}), ni = {
	clipPath: "inset(50%)",
	position: "fixed",
	top: 0,
	left: 0
}, ri = /*#__PURE__*/ s.createContext(null), ii = /*#__PURE__*/ Yr("portal");
function ai(e) {
	e === void 0 && (e = {});
	let { id: t, root: n } = e, r = zr(), i = si(), [a, o] = s.useState(null), c = s.useRef(null);
	return Z(() => () => {
		a?.remove(), queueMicrotask(() => {
			c.current = null;
		});
	}, [a]), Z(() => {
		if (!r || c.current) return;
		let e = t ? document.getElementById(t) : null;
		if (!e) return;
		let n = document.createElement("div");
		n.id = r, n.setAttribute(ii, ""), e.appendChild(n), c.current = n, o(n);
	}, [t, r]), Z(() => {
		if (n === null || !r || c.current) return;
		let e = n || i?.portalNode;
		e && !Ve(e) && (e = e.current), e ||= document.body;
		let a = null;
		t && (a = document.createElement("div"), a.id = t, e.appendChild(a));
		let s = document.createElement("div");
		s.id = r, s.setAttribute(ii, ""), e = a || e, e.appendChild(s), c.current = s, o(s);
	}, [
		t,
		n,
		r,
		i
	]), a;
}
function oi(e) {
	let { children: t, id: n, root: r, preserveTabOrder: i = !0 } = e, c = ai({
		id: n,
		root: r
	}), [l, u] = s.useState(null), d = s.useRef(null), f = s.useRef(null), p = s.useRef(null), m = s.useRef(null), h = l?.modal, _ = l?.open, v = !!l && !l.modal && l.open && i && !!(r || c);
	return s.useEffect(() => {
		if (!c || !i || h) return;
		function e(e) {
			c && Sn(e) && (e.type === "focusin" ? wn : Cn)(c);
		}
		return c.addEventListener("focusin", e, !0), c.addEventListener("focusout", e, !0), () => {
			c.removeEventListener("focusin", e, !0), c.removeEventListener("focusout", e, !0);
		};
	}, [
		c,
		i,
		h
	]), s.useEffect(() => {
		c && (_ || wn(c));
	}, [_, c]), /*#__PURE__*/ o(ri.Provider, {
		value: s.useMemo(() => ({
			preserveTabOrder: i,
			beforeOutsideRef: d,
			afterOutsideRef: f,
			beforeInsideRef: p,
			afterInsideRef: m,
			portalNode: c,
			setFocusManagerState: u
		}), [i, c]),
		children: [
			v && c && /*#__PURE__*/ a(ti, {
				"data-type": "outside",
				ref: d,
				onFocus: (e) => {
					if (Sn(e, c)) {
						var t;
						(t = p.current) == null || t.focus();
					} else xn(l ? l.domReference : null)?.focus();
				}
			}),
			v && c && /*#__PURE__*/ a("span", {
				"aria-owns": c.id,
				style: ni
			}),
			c && /*#__PURE__*/ g.createPortal(t, c),
			v && c && /*#__PURE__*/ a(ti, {
				"data-type": "outside",
				ref: f,
				onFocus: (e) => {
					if (Sn(e, c)) {
						var t;
						(t = m.current) == null || t.focus();
					} else bn(l ? l.domReference : null)?.focus(), l != null && l.closeOnFocusOut && l?.onOpenChange(!1, e.nativeEvent, "focus-out");
				}
			})
		]
	});
}
var si = () => s.useContext(ri);
function ci(e) {
	let { open: t = !1, onOpenChange: n, elements: r } = e, i = zr(), a = s.useRef({}), [o] = s.useState(() => Wr()), c = qr() != null;
	if (process.env.NODE_ENV !== "production") {
		let e = r.reference;
		e && !H(e) && Hr("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
	}
	let [l, u] = s.useState(r.reference), d = _n((e, t, r) => {
		a.current.openEvent = e ? t : void 0, o.emit("openchange", {
			open: e,
			event: t,
			reason: r,
			nested: c
		}), n?.(e, t, r);
	}), f = s.useMemo(() => ({ setPositionReference: u }), []), p = s.useMemo(() => ({
		reference: l || r.reference || null,
		floating: r.floating || null,
		domReference: r.reference
	}), [
		l,
		r.reference,
		r.floating
	]);
	return s.useMemo(() => ({
		dataRef: a,
		open: t,
		onOpenChange: d,
		elements: p,
		events: o,
		floatingId: i,
		refs: f
	}), [
		t,
		d,
		p,
		o,
		i,
		f
	]);
}
function li(e) {
	let { elements: t, ...n } = e === void 0 ? {} : e, { nodeId: r } = n, i = ci({
		...n,
		elements: {
			reference: t?.reference ?? null,
			floating: t?.floating ?? null
		}
	}), a = n.rootContext || i, o = a.elements, [c, l] = s.useState(null), [u, d] = s.useState(null), f = o?.domReference || c, p = s.useRef(null), m = Jr();
	Z(() => {
		f && (p.current = f);
	}, [f]);
	let h = yr({
		...n,
		elements: {
			...o,
			...u && { reference: u }
		}
	}), g = s.useCallback((e) => {
		let t = H(e) ? {
			getBoundingClientRect: () => e.getBoundingClientRect(),
			getClientRects: () => e.getClientRects(),
			contextElement: e
		} : e;
		d(t), h.refs.setReference(t);
	}, [h.refs]), _ = s.useCallback((e) => {
		(H(e) || e === null) && (p.current = e, l(e)), (H(h.refs.reference.current) || h.refs.reference.current === null || e !== null && !H(e)) && h.refs.setReference(e);
	}, [h.refs]), v = s.useMemo(() => ({
		...h.refs,
		setReference: _,
		setPositionReference: g,
		domReference: p
	}), [
		h.refs,
		_,
		g
	]), y = s.useMemo(() => ({
		...h.elements,
		domReference: f
	}), [h.elements, f]), b = s.useMemo(() => ({
		...h,
		...a,
		refs: v,
		elements: y,
		nodeId: r
	}), [
		h,
		v,
		y,
		r,
		a
	]);
	return Z(() => {
		a.dataRef.current.floatingContext = b;
		let e = m?.nodesRef.current.find((e) => e.id === r);
		e && (e.context = b);
	}), s.useMemo(() => ({
		...h,
		context: b,
		refs: v,
		elements: y
	}), [
		h,
		v,
		y,
		b
	]);
}
function ui() {
	return an() && rn();
}
function di(e, t) {
	t === void 0 && (t = {});
	let { open: n, onOpenChange: r, events: i, dataRef: a, elements: o } = e, { enabled: c = !0, visibleOnly: l = !0 } = t, u = s.useRef(!1), d = s.useRef(-1), f = s.useRef(!0);
	s.useEffect(() => {
		if (!c) return;
		let e = B(o.domReference);
		function t() {
			!n && U(o.domReference) && o.domReference === cn(X(o.domReference)) && (u.current = !0);
		}
		function r() {
			f.current = !0;
		}
		function i() {
			f.current = !1;
		}
		return e.addEventListener("blur", t), ui() && (e.addEventListener("keydown", r, !0), e.addEventListener("pointerdown", i, !0)), () => {
			e.removeEventListener("blur", t), ui() && (e.removeEventListener("keydown", r, !0), e.removeEventListener("pointerdown", i, !0));
		};
	}, [
		o.domReference,
		n,
		c
	]), s.useEffect(() => {
		if (!c) return;
		function e(e) {
			let { reason: t } = e;
			(t === "reference-press" || t === "escape-key") && (u.current = !0);
		}
		return i.on("openchange", e), () => {
			i.off("openchange", e);
		};
	}, [i, c]), s.useEffect(() => () => {
		$(d);
	}, []);
	let p = s.useMemo(() => ({
		onMouseLeave() {
			u.current = !1;
		},
		onFocus(e) {
			if (u.current) return;
			let t = un(e.nativeEvent);
			if (l && H(t)) {
				if (ui() && !e.relatedTarget) {
					if (!f.current && !dn(t)) return;
				} else if (!fn(t)) return;
			}
			r(!0, e.nativeEvent, "focus");
		},
		onBlur(e) {
			u.current = !1;
			let t = e.relatedTarget, n = e.nativeEvent, i = H(t) && t.hasAttribute(Yr("focus-guard")) && t.getAttribute("data-type") === "outside";
			d.current = window.setTimeout(() => {
				let e = cn(o.domReference ? o.domReference.ownerDocument : document);
				!t && e === o.domReference || ln(a.current.floatingContext?.refs.floating.current, e) || ln(o.domReference, e) || i || r(!1, n, "focus");
			});
		}
	}), [
		a,
		o.domReference,
		r,
		l
	]);
	return s.useMemo(() => c ? { reference: p } : {}, [c, p]);
}
function fi(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i = n === "item", a = e;
	if (i && e) {
		let { [Er]: t, [Dr]: n, ...r } = e;
		a = r;
	}
	return {
		...n === "floating" && {
			tabIndex: -1,
			[Tr]: ""
		},
		...a,
		...t.map((t) => {
			let r = t ? t[n] : null;
			return typeof r == "function" ? e ? r(e) : null : r;
		}).concat(e).reduce((e, t) => (t && Object.entries(t).forEach((t) => {
			let [n, a] = t;
			if (!(i && [Er, Dr].includes(n))) {
				if (n.indexOf("on") === 0) {
					if (r.has(n) || r.set(n, []), typeof a == "function") {
						var o;
						(o = r.get(n)) == null || o.push(a), e[n] = function() {
							var e = [...arguments];
							return r.get(n)?.map((t) => t(...e)).find((e) => e !== void 0);
						};
					}
				} else e[n] = a;
			}
		}), e), {})
	};
}
function pi(e) {
	e === void 0 && (e = []);
	let t = e.map((e) => e?.reference), n = e.map((e) => e?.floating), r = e.map((e) => e?.item), i = s.useCallback((t) => fi(t, e, "reference"), t), a = s.useCallback((t) => fi(t, e, "floating"), n), o = s.useCallback((t) => fi(t, e, "item"), r);
	return s.useMemo(() => ({
		getReferenceProps: i,
		getFloatingProps: a,
		getItemProps: o
	}), [
		i,
		a,
		o
	]);
}
// src/components/overlay/Tooltip/types.ts
var mi = {
	top: "top",
	bottom: "bottom",
	left: "left",
	right: "right"
}, hi = {
	dark: "dark",
	light: "light"
}, gi = {
	static: "static",
	dynamic: "dynamic"
}, _i = 12, vi = 8, yi = 12, bi = 8, xi = (e) => {
	let { children: t, content: n, placement: r = mi.top, variant: s = hi.dark, visible: c, showCaret: u = !0, className: f, ...p } = e, g = d(), _ = m(null), [v, y] = h(!1), b = c !== void 0, x = b ? c : v, { refs: S, floatingStyles: C, context: w } = li({
		placement: r,
		open: x,
		onOpenChange: y,
		middleware: [
			xr(_i),
			Cr(),
			Sr({ padding: vi }),
			wr({ element: _ })
		],
		whileElementsMounted: cr
	}), { getReferenceProps: T, getFloatingProps: E } = pi([$r(w, {
		enabled: !b,
		move: !1
	}), di(w, { enabled: !b })]), D = [t.props["aria-describedby"], x ? g : void 0].filter(Boolean).join(" ") || void 0, O = l(t, { "aria-describedby": D }), k = ["tooltip-wrapper", f].filter(Boolean).join(" ");
	return /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ a("span", {
		ref: S.setReference,
		className: k,
		...T(p),
		children: O
	}), x && /* @__PURE__ */ a(oi, { children: /* @__PURE__ */ o("span", {
		...E(),
		ref: S.setFloating,
		id: g,
		role: "tooltip",
		className: `tooltip-surface tooltip-variant-${s}`,
		style: C,
		children: [/* @__PURE__ */ a("span", {
			className: "tooltip-content",
			children: n
		}), u && /* @__PURE__ */ a(Ur, {
			ref: _,
			context: w,
			className: `tooltip-dynamic-arrow-${s}`,
			width: yi,
			height: bi
		})]
	}) })] });
}, Si = (e) => {
	let { children: t, content: n, placement: r = mi.top, variant: i = hi.dark, visible: s, showCaret: c = !0, className: u, ...f } = e, p = d(), m = [t.props["aria-describedby"], p].filter(Boolean).join(" "), h = [
		"tooltip-wrapper",
		s === !0 && "tooltip-wrapper-visible",
		s === !1 && "tooltip-wrapper-hidden",
		u
	].filter(Boolean).join(" "), g = l(t, { "aria-describedby": m });
	return /* @__PURE__ */ o("span", {
		className: h,
		...f,
		children: [g, /* @__PURE__ */ o("span", {
			id: p,
			role: "tooltip",
			className: `tooltip-box tooltip-variant-${i}`,
			"data-placement": r,
			children: [/* @__PURE__ */ a("span", {
				className: "tooltip-content",
				children: n
			}), c && /* @__PURE__ */ a("span", { className: "tooltip-caret" })]
		})]
	});
}, Ci = (e) => {
	let { position: t = gi.static, ...n } = e;
	return t === gi.dynamic ? /* @__PURE__ */ a(xi, { ...n }) : /* @__PURE__ */ a(Si, { ...n });
}, wi = (e) => {
	let { "aria-label": t, heading: n, header: r, onClose: i, children: s } = e, c = m(null), l = m(null);
	return f(() => {
		let e = c.current;
		if (e !== null) return e.showModal(), l.current?.focus(), () => e.close();
	}, []), /* @__PURE__ */ o("dialog", {
		ref: c,
		className: "flyout",
		"aria-label": t,
		onCancel: (e) => {
			e.preventDefault(), i();
		},
		children: [/* @__PURE__ */ a("div", {
			className: "flyout-scrim",
			onClick: i,
			"aria-hidden": "true",
			"data-testid": "flyout-scrim"
		}), /* @__PURE__ */ o("div", {
			ref: l,
			className: "flyout-panel",
			tabIndex: -1,
			children: [
				/* @__PURE__ */ o("div", {
					className: "flyout-title-bar",
					children: [/* @__PURE__ */ a("span", {
						className: "flyout-heading",
						children: n
					}), /* @__PURE__ */ a(P, {
						intent: "neutral",
						variant: "ghost",
						size: "s",
						icon: R.USER_INTERFACE_CLOSE,
						iconPosition: "leading",
						iconColor: "grey",
						iconSize: 14,
						"aria-label": "Close",
						onClick: i
					})]
				}),
				r !== void 0 && /* @__PURE__ */ a("div", {
					className: "flyout-header",
					children: r
				}),
				/* @__PURE__ */ a("div", {
					className: "flyout-body",
					children: s
				})
			]
		})]
	});
}, Ti = [
	"informational",
	"positive",
	"negative"
], Ei = {
	informational: R.USER_INTERFACE_EXCLAMATION_MARK_CIRCLE,
	positive: R.USER_INTERFACE_CHECKMARK_CIRCLE,
	negative: R.USER_INTERFACE_EXCLAMATION_MARK_TRIANGLE
}, Di = ({ children: e, variant: t = "informational", onClose: n, className: r, ...i }) => {
	let s = [
		"toast",
		`variant-${t}`,
		r
	].filter(Boolean).join(" "), c = Ei[t];
	return /* @__PURE__ */ o("div", {
		className: s,
		role: "alert",
		...i,
		children: [/* @__PURE__ */ o("div", {
			className: "toast-content",
			children: [/* @__PURE__ */ a("span", {
				className: "toast-icon",
				children: /* @__PURE__ */ a(k, {
					name: c,
					size: 16
				})
			}), /* @__PURE__ */ a("span", {
				className: "toast-text",
				children: e
			})]
		}), n ? /* @__PURE__ */ a("div", {
			className: "toast-actions",
			children: /* @__PURE__ */ a(P, {
				"aria-label": "Close",
				icon: R.USER_INTERFACE_CLOSE_BOLD,
				iconPosition: N.leading,
				iconSize: 8,
				intent: "neutral",
				onClick: n,
				size: "xs",
				variant: "ghost"
			})
		}) : null]
	});
}, Oi = R.USER_INTERFACE_CHECKMARK, ki = {
	unchecked: "unchecked",
	checked: "checked",
	omitted: "omitted",
	implicit: "implicit",
	mixed: "mixed"
}, Ai = (e) => {
	switch (e) {
		case "checked":
		case "implicit": return !0;
		case "mixed": return "mixed";
		case "omitted":
		case "unchecked": return !1;
	}
}, ji = ({ state: e, onChange: t, disabled: n = !1, ...r }) => {
	let i = [
		"checkbox",
		`state-${e}`,
		n ? "disabled" : null
	].filter(Boolean).join(" ");
	return /* @__PURE__ */ a("button", {
		"aria-checked": Ai(e),
		className: i,
		disabled: n,
		role: "checkbox",
		type: "button",
		onClick: t,
		...r,
		children: /* @__PURE__ */ o("span", {
			"aria-hidden": "true",
			className: "checkbox-box",
			children: [
				(e === "checked" || e === "implicit") && /* @__PURE__ */ a(k, {
					color: "white",
					name: Oi,
					size: 10
				}),
				e === "omitted" && /* @__PURE__ */ a(k, {
					color: "white",
					name: R.USER_INTERFACE_CLOSE_BOLD,
					size: 8
				}),
				e === "mixed" && /* @__PURE__ */ a("span", { className: "checkbox-mixed-bar" })
			]
		})
	});
}, Mi = {
	small: "small",
	medium: "medium",
	large: "large"
}, Ni = "--fill", Pi = (e) => /* @__PURE__ */ a("svg", {
	viewBox: "0 0 200 250.2",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("circle", {
		cx: "140.8",
		cy: "59.2",
		r: "59.2"
	})
}), Fi = (e) => /* @__PURE__ */ o("svg", {
	viewBox: "0 0 200 250.2",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", { d: "M93.1,250.2l-59.9-24.4C13.1,217.6,0,198.1,0,176.5V59.2l59.7,24.3c20.2,8.2,33.4,27.8,33.4,49.6V250.2z" }), /* @__PURE__ */ a("circle", {
		cx: "140.8",
		cy: "59.2",
		r: "59.2"
	})]
}), Ii = (e) => {
	let { label: t, sublabel: n, progress: r, size: i = Mi.medium, className: s, ...c } = e, l = r === void 0, u = l ? 0 : Math.min(1, Math.max(0, r / 100)), f = { [Ni]: u }, p = [
		"rwave-loader",
		`rwave-loader-size-${i}`,
		l ? "rwave-loader-indeterminate" : null,
		s
	].filter(Boolean).join(" "), m = d(), h = `${m}-label`, g = `${m}-sublabel`, _ = [t ? h : null, n ? g : null].filter(Boolean).join(" "), v = _ ? { "aria-labelledby": _ } : { "aria-label": "Loading" }, y = l ? {
		role: "status",
		"aria-live": "polite",
		...v
	} : {
		role: "progressbar",
		"aria-valuenow": Math.round(u * 100),
		"aria-valuemin": 0,
		"aria-valuemax": 100,
		...v
	};
	return /* @__PURE__ */ o("div", {
		className: p,
		...y,
		...c,
		children: [
			/* @__PURE__ */ o("div", {
				className: "rwave-loader-logo",
				style: f,
				children: [
					/* @__PURE__ */ a(Fi, {
						"aria-hidden": !0,
						className: "rwave-loader-svg rwave-loader-track"
					}),
					/* @__PURE__ */ a(Fi, {
						"aria-hidden": !0,
						className: "rwave-loader-svg rwave-loader-wave rwave-loader-back-wave rwave-loader-back-wave-breathing"
					}),
					/* @__PURE__ */ a(Fi, {
						"aria-hidden": !0,
						className: "rwave-loader-svg rwave-loader-wave rwave-loader-fill rwave-loader-fill-breathing"
					}),
					/* @__PURE__ */ a(Pi, {
						"aria-hidden": !0,
						className: "rwave-loader-svg rwave-loader-dot-pulse"
					})
				]
			}),
			t ? /* @__PURE__ */ a("p", {
				className: "rwave-loader-label",
				id: h,
				children: t
			}) : null,
			n ? /* @__PURE__ */ a("p", {
				className: "rwave-loader-sublabel",
				id: g,
				children: n
			}) : null
		]
	});
}, Li = {
	short: "short",
	medium: "medium",
	long: "long",
	full: "full"
}, Ri = {
	small: "small",
	medium: "medium",
	large: "large"
}, zi = {
	small: "small",
	medium: "medium",
	large: "large"
}, Bi = (e) => {
	let t = e.shape === "circle" ? `skeleton skeleton-circle skeleton-size-${e.size ?? zi.medium}` : `skeleton skeleton-bar skeleton-width-${e.width ?? Li.full} skeleton-height-${e.height ?? Ri.small}`;
	return /* @__PURE__ */ a("span", {
		className: t,
		"aria-hidden": "true"
	});
}, Vi = { glyph: "glyph" }, Hi = 200, Ui = 250.2, Wi = Hi / Ui, Gi = (e) => typeof e == "number" ? e * Wi : void 0, Ki = ({ variant: e = Vi.glyph, size: t = 24, title: n, className: r, ...i }) => {
	let s = ["regard-mark", r].filter(Boolean).join(" "), c = n ? {
		role: "img",
		"aria-label": n
	} : { "aria-hidden": !0 };
	return /* @__PURE__ */ o("svg", {
		className: s,
		height: t,
		viewBox: `0 0 ${Hi} ${Ui}`,
		width: Gi(t),
		xmlns: "http://www.w3.org/2000/svg",
		...c,
		...i,
		children: [/* @__PURE__ */ a("path", { d: "M93.1,250.2l-59.9-24.4C13.1,217.6,0,198.1,0,176.5V59.2l59.7,24.3c20.2,8.2,33.4,27.8,33.4,49.6V250.2z" }), /* @__PURE__ */ a("circle", {
			cx: "140.8",
			cy: "59.2",
			r: "59.2"
		})]
	});
}, qi = {
	small: "small",
	medium: "medium"
}, Ji = {
	leading: "leading",
	trailing: "trailing"
}, Yi = {
	small: 14,
	medium: 16
}, Xi = (e, t) => {
	let n = e.iconPosition ?? Ji.leading, r = e.label === void 0, s = e.icon === void 0 ? null : /* @__PURE__ */ a(k, {
		name: e.icon,
		size: t
	});
	return /* @__PURE__ */ o(i, { children: [
		n === Ji.leading && s,
		!r && /* @__PURE__ */ a("span", {
			className: "segment-label",
			children: e.label
		}),
		n === Ji.trailing && s
	] });
}, Zi = (e, t, n) => {
	let r = t.indexOf(e);
	return r === -1 || t.length === 0 ? null : n === "Home" ? t[0] ?? null : n === "End" ? t[t.length - 1] ?? null : t[(r + (n === "ArrowRight" || n === "ArrowDown" ? 1 : -1) + t.length) % t.length] ?? null;
}, Qi = (e) => {
	let { disabled: t = !1, items: n, onValueChange: r, size: i = qi.medium, value: o, onKeyDown: s, className: c, ...l } = e, u = Yi[i], [d, f] = h(() => {
		let e = n.filter((e) => !(t || e.disabled)).map((e) => e.value);
		return e.includes(o) ? o : e[0];
	});
	return /* @__PURE__ */ a("div", {
		className: (0, L.default)("segmented-control", `size-${i}`, c),
		role: "group",
		onKeyDown: (e) => {
			if (s?.(e), e.defaultPrevented) return;
			let t = e.target;
			if (!(t instanceof HTMLButtonElement) || t.dataset.segmentValue === void 0) return;
			let n = e.key === "ArrowLeft", i = e.key === "ArrowRight", a = e.key === "Home" || e.key === "End";
			if (e.key === "Enter" || e.key === " ") {
				let n = t.dataset.segmentValue;
				n !== void 0 && (e.preventDefault(), r(n));
				return;
			}
			if (!n && !i && !a) return;
			let o = Zi(t, Array.from(e.currentTarget.querySelectorAll("button[data-segment-value]:not(:disabled)")), e.key);
			o !== null && (e.preventDefault(), o.focus());
		},
		...l,
		children: n.map((e) => {
			let n = e.label === void 0, i = o === e.value, s = d === e.value, c = t || !!e.disabled;
			return /* @__PURE__ */ a("button", {
				"aria-label": e["aria-label"],
				"aria-pressed": i,
				className: (0, L.default)("segment", { "icon-only": n }),
				"data-disabled": c ? "" : void 0,
				"data-state": i ? "active" : "inactive",
				"data-segment-value": e.value,
				disabled: c,
				tabIndex: s ? 0 : -1,
				type: "button",
				onClick: () => r(e.value),
				onFocus: () => f(e.value),
				children: Xi(e, u)
			}, e.value);
		})
	});
}, $i = {
	none: "none",
	md: "md"
}, ea = {
	none: "none",
	sm: "sm",
	md: "md",
	lg: "lg",
	xl: "xl"
}, ta = (e) => {
	let { padding: t = $i.md, elevation: n = ea.sm, borderColor: r, clipContent: i = !1, className: o, style: s, ...c } = e, l = r === void 0 ? void 0 : { "--card-border-color": `var(--color-${r})` };
	return /* @__PURE__ */ a("div", {
		className: (0, L.default)("card", `card--padding-${t}`, `card--elevation-${n}`, { "card--clip": i }, o),
		style: {
			...s,
			...l
		},
		...c
	});
}, na = {
	h2: "h2",
	h3: "h3",
	h4: "h4"
}, ra = (e) => {
	let { title: t, subtitle: n, titleAs: r = na.h2, footer: i, headerAction: s, borderColor: c, children: l, className: u, ...f } = e, p = d();
	return /* @__PURE__ */ a("section", {
		className: (0, L.default)("section-card", u),
		"aria-labelledby": p,
		...f,
		children: /* @__PURE__ */ o(ta, {
			className: "section-card-stack",
			padding: "none",
			borderColor: c,
			children: [
				/* @__PURE__ */ o("div", {
					className: "section-card-header",
					children: [
						/* @__PURE__ */ a(r, {
							id: p,
							className: "section-card-title",
							children: t
						}),
						s !== void 0 && /* @__PURE__ */ a("div", {
							className: "section-card-header-action",
							children: s
						}),
						n !== void 0 && /* @__PURE__ */ a("p", {
							className: "section-card-subtitle",
							children: n
						})
					]
				}),
				/* @__PURE__ */ a("div", {
					className: "section-card-body",
					children: l
				}),
				i !== void 0 && /* @__PURE__ */ a("div", {
					className: "section-card-footer",
					children: i
				})
			]
		})
	});
}, ia = (e) => {
	let { title: t, defaultOpen: n = !0, borderColor: r = "grey-200", headerEnd: i, children: s, className: c, ...l } = e, [u, f] = h(n), p = d();
	return /* @__PURE__ */ o(ta, {
		className: (0, L.default)("collapsible-card", c),
		padding: "none",
		clipContent: !0,
		borderColor: r,
		elevation: "none",
		...l,
		children: [/* @__PURE__ */ o("div", {
			className: (0, L.default)("collapsible-card-header-bar", { "collapsible-card-header-bar--with-end": i != null }),
			children: [/* @__PURE__ */ o("button", {
				type: "button",
				className: "collapsible-card-header",
				"aria-expanded": u,
				"aria-controls": p,
				onClick: () => f((e) => !e),
				children: [/* @__PURE__ */ a("span", {
					className: "collapsible-card-chevron",
					"data-open": u,
					"aria-hidden": "true",
					children: /* @__PURE__ */ a(k, {
						name: R.ARROWS_CHEVRON_DOWN,
						size: 14,
						color: "grey"
					})
				}), /* @__PURE__ */ a("span", {
					className: "collapsible-card-title",
					children: t
				})]
			}), i != null && /* @__PURE__ */ a("div", {
				className: "collapsible-card-header-end",
				children: i
			})]
		}), u && /* @__PURE__ */ a("div", {
			id: p,
			className: "collapsible-card-body",
			children: s
		})]
	});
};
export { Ee as AVATAR_COLORS, Te as AVATAR_SIZES, De as Avatar, ee as BADGE_COLORS, I as BADGE_SIZES, F as BADGE_TYPES, A as BUTTON_COLORS, M as BUTTON_SIZES, j as BUTTON_STYLES, ne as Badge, P as Button, ea as CARD_ELEVATIONS, $i as CARD_PADDINGS, ki as CHECKBOX_STATES, ie as CHIP_COLORS, re as CHIP_SIZES, oe as CHIP_STATES, ae as CHIP_VARIANTS, ta as Card, ji as Checkbox, le as Chip, ia as CollapsibleCard, Me as FilterableSelect, wi as Flyout, D as ICON_COLORS, R as ICON_NAMES, k as Icon, Se as MENU_ITEM_SELECTED_INDICATORS, xe as Menu, Ce as MenuItem, n as RADIO_BUTTON_SIZES, r as RADIO_GROUP_ORIENTATIONS, Vi as REGARD_MARK_VARIANTS, Mi as RWAVE_LOADER_SIZES, Ii as RWaveLoader, e as RadioButton, t as RadioGroup, Ki as RegardMark, na as SECTION_CARD_TITLE_ELEMENTS, Ji as SEGMENTED_CONTROL_ICON_POSITIONS, qi as SEGMENTED_CONTROL_SIZES, Ri as SKELETON_HEIGHTS, zi as SKELETON_SIZES, Li as SKELETON_WIDTHS, Oe as SearchInput, ra as SectionCard, Qi as SegmentedControl, Bi as Skeleton, ue as TAB_BAR_SIZES, de as TAB_ICON_POSITIONS, Ne as TEXT_INPUT_SIZE, z as TEXT_INPUT_STATE, Ti as TOAST_VARIANTS, mi as TOOLTIP_PLACEMENTS, gi as TOOLTIP_POSITIONS, hi as TOOLTIP_VARIANTS, _e as TabBar, Re as TextInput, Di as Toast, Ci as Tooltip, we as getInitials };
